/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect, useRef, useId, Fragment } from "react";
import ChecklistDocumentos from "./ChecklistDocumentos";
import SeletorLocalizacao from "./SeletorLocalizacao";
import { dataISO, hojeISO } from "./datas";
import JanelaPedidoCpcv from "./PedidoCpcv";
import { htmlParaPdf } from "./PdfCpcv";
import { herdado, diferencas, aplicar } from "./Heranca";
import { paleta } from "./tokens";
import EntidadeEscritura from "./Entidades";
import {
  ArrowLeft, ArrowRight, Check, Save, CheckCircle2, Send, FileDown, XCircle, Paperclip, Home, User, Users,
  FileText, FolderOpen, CalendarDays, ChevronDown, ChevronRight, RefreshCw, Lock, Link2, Crown, AlertTriangle, Building2,
} from "lucide-react";

const CONSULTORES = [
  "Ana Lucas","Carlos Matos","Cátia Ribeiro","Filipa Pereira","Guilherme Nunes",
  "Hernâni Ferreira","Paulo Branco","Rodrigo Francisco","Sandra Ferreira","Sérgio Marques",
  "Silvia Bento","Sónia Henriques","Tony Silva","Vitor Melo","Zita Valente"
];
const AGENCIAS = [{ id: "white", label: "RE/MAX White" }, { id: "white_ii", label: "RE/MAX White II" }];
const TIPOS_IMOVEL = ["Apartamento","Moradia","Loja","Escritório","Terreno","Garagem","Armazém","Quinta / Herdade","Prédio","Outro"];
const ESTADO_CIVIL_OPS = ["Solteiro(a)","Casado(a)","Divorciado(a)","Viúvo(a)"];
const REGIME_CASAMENTO_OPS = ["Comunhão de adquiridos","Comunhão geral","Separação de bens"];
export const RESPONSAVEL_FINANCIAMENTO_OPS = ["MaxFinance White","Outro intermediário de crédito","Cliente trata","Ainda não definido"];

function formatEur(v) { if (!v && v!==0) return ""; return Number(v).toLocaleString("pt-PT",{minimumFractionDigits:0,maximumFractionDigits:0})+" €"; }
function parseEur(v) { return v.replace(/[^0-9]/g,""); }
function calcDataLimite(dataAssinatura, prazoTipo, prazo) {
  if (!dataAssinatura) return null;
  if (prazoTipo==="data" && prazo) return prazo;
  if (prazoTipo==="dias" && prazo) { const d=new Date(dataAssinatura); d.setDate(d.getDate()+Number(prazo)); return dataISO(d); }
  return null;
}
function gerarToken() { return Math.random().toString(36).substring(2) + Date.now().toString(36); }
function gerarId(ref, consultorNome) {
  const slug = (s) => (s||"").normalize("NFD").replace(/[̀-ͯ]/g,"").replace(/[^a-zA-Z0-9]/g,"").toLowerCase();
  const consSlug = slug(consultorNome) || "agente";
  const refSlug = ref ? String(ref).trim() : Math.floor(Math.random()*9000+1000);
  return `CPCV-${refSlug}-${consSlug}`;
}

export function pessoaVazia() {
  return { nome: "", naturalidade: "", cc: "", validade_cc: "", nif: "", telefone: "", email: "", estado_civil: "", regime_casamento: "", casou_portugal: true, pais_casamento: "", morada: "", codigo_postal: "", conjuge: { nome: "", naturalidade: "", cc: "", validade_cc: "", nif: "", telefone: "", email: "" } };
}
export function procuradorVazio() { return { nome: "", naturalidade: "", cc: "", validade_cc: "", nif: "", telefone: "", email: "", estado_civil: "", morada: "", codigo_postal: "" }; }
export function imovelVazio() { return { tipo_imovel: "", artigo_matricial: "", fracao: "", descricao_predial: "", tipologia: "", morada: "", codigo_postal: "", concelho: "", freguesia: "", licenca_utilizacao: "", licenca_data: "", licenca_cm: "", condominio: false, empresa_condominio: "", valor_venda: "", valor_sinal: "", valor_reforco: "", data_reforco: "" }; }
export function partVazio() { return { tipo: "particular", ...pessoaVazia(), autorizantes: [], procuradores: [] }; }
export function herancaVazia() { return { tipo: "heranca", nome_heranca: "", herdeiros: [pessoaVazia()], autorizantes: [], procuradores: [] }; }
export function empresaVazia() { return { tipo: "empresa", nome_empresa: "", nipc: "", morada_sede: "", codigo_postal_sede: "", tem_cae_imoveis: null, ata_ou_socios: "ata", gerentes: [{ nome: "", naturalidade: "", cc: "", validade_cc: "", nif: "", telefone: "", email: "", estado_civil: "", residencia: "" }], procuradores: [] }; }

const S = {
  input: { width: "100%", padding: "10px 12px", border: "1px solid #C9CED8", borderRadius: 8, fontSize: 14, fontFamily: "inherit", background: "#fff", color: "#1A1D24", boxSizing: "border-box" },
  label: { fontSize: 12.5, fontWeight: 500, color: "#5B6272", marginBottom: 5, display: "block" },
  secao: { background: "#fff", borderRadius: 12, border: "1px solid #E3E6EC", padding: "20px 24px", marginBottom: 16 },
  titulo: { fontSize: 16, fontWeight: 600, color: "#fff", background: "linear-gradient(90deg, #0B1B3D 0%, #1E3566 45%, #4A6BA8 100%)", margin: "-20px -24px 16px", padding: "11px 24px", borderRadius: "11px 11px 0 0", display: "flex", alignItems: "center", gap: 8 },
  barra: { background: "linear-gradient(90deg, #0B1B3D 0%, #1E3566 45%, #4A6BA8 100%)", color: "#fff", margin: "-20px -24px 16px", padding: "11px 24px", borderRadius: "11px 11px 0 0" },
  g2: { display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 },
  g3: { display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 12 },
  gNome: { display: "grid", gridTemplateColumns: "3fr 1fr", gap: 12 },
  gMorada: { display: "grid", gridTemplateColumns: "3fr 1fr", gap: 12 },
  sub: { background: "#F4F6FA", borderRadius: 10, border: "1px solid #E3E6EC", padding: "14px 18px", marginTop: 12 },
  btnAdd: { background: "#fff", border: "1px dashed #E3E6EC", borderRadius: 8, padding: "8px 16px", fontSize: 13, fontWeight: 600, color: "#0B1B3D", cursor: "pointer", width: "100%", marginTop: 10 },
  btnRem: { background: "#fef2f2", border: "none", borderRadius: 6, padding: "4px 10px", fontSize: 11, color: "#ef4444", cursor: "pointer", fontWeight: 600 },
};

// Botões da barra de ações: 4 variantes, sempre as mesmas cores do sistema visual.
const SUBT = { fontSize: 14, fontWeight: 600, color: "#0B1B3D", marginBottom: 12 };
const FASES = [
  { id: "cabecalho", sec: "cpcv-cabecalho", label: "Cabeçalho" },
  { id: "imoveis", sec: "cpcv-imoveis", label: "Imóveis" },
  { id: "vendedores", sec: "cpcv-vendedores", label: "Vendedores" },
  { id: "compradores", sec: "cpcv-compradores", label: "Compradores" },
  { id: "condicoes", sec: "cpcv-condicoes", label: "Condições" },
  { id: "documentos", sec: "cpcv-documentos", label: "Documentos" },
  { id: "revisao", sec: "cpcv-revisao", label: "Rever e enviar" },
];
const FASES_COM_DADOS = ["cabecalho", "imoveis", "vendedores", "compradores", "condicoes"];
const FASE_DE_SEC = { "cpcv-agendamento": "escritura", "cpcv-cabecalho": "cabecalho", "cpcv-imoveis": "imoveis", "cpcv-vendedores": "vendedores", "cpcv-compradores": "compradores", "cpcv-condicoes": "condicoes", "cpcv-documentos": "documentos", "cpcv-docsnegocio": "documentos", "cpcv-revisao": "revisao" };
const BTN_BASE = { borderRadius: 10, padding: "11px 20px", fontSize: 13.5, fontWeight: 600, cursor: "pointer", display: "inline-flex", alignItems: "center", gap: 8, border: "1.5px solid transparent", fontFamily: "inherit" };
const B = {
  primario: { ...BTN_BASE, background: "#1E3566", color: "#fff", borderColor: "#1E3566" },
  secundario: { ...BTN_BASE, background: "#fff", color: "#0B1B3D", borderColor: "#C9CED8" },
  sucesso: { ...BTN_BASE, background: "#067647", color: "#fff" },
  perigo: { ...BTN_BASE, background: "#fff", color: "#B42318", borderColor: "#F3B8B2" },
};
const ICONES_SEC = { "🏠": Home, "👤": User, "👥": Users, "📝": FileText, "📎": Paperclip, "📁": FolderOpen };
const ESTADOS_ROTULO = { rascunho: "Rascunho", aguarda_externo: "À espera do externo", completo: "Completo", pdf_gerado: "PDF gerado", enviado: "Enviado", cancelado: "Cancelado" };
// Só aspeto: foco visível no teclado, cabeçalho fixo, e campos lado a lado que passam a ficar em coluna no telemóvel.
const ESTILO_CPCV = `
.cpcv-form input:focus-visible, .cpcv-form select:focus-visible, .cpcv-form textarea:focus-visible { outline: 2px solid #1E3566 !important; outline-offset: 1px; border-color: #1E3566 !important; }
.cpcv-form button:focus-visible, .cpcv-form [role="button"]:focus-visible { outline: 2px solid #1E3566; outline-offset: 2px; }
.cpcv-form button:not(:disabled):hover { filter: brightness(0.95); }
.cpcv-seccao { scroll-margin-top: 150px; }
.cpcv-cab { position: sticky; top: 0; z-index: 20; background: #F4F6FA; padding: 10px 0 0; margin-bottom: 14px; border-bottom: 1px solid #E3E6EC; }
.cpcv-indice { display: flex; gap: 4px; overflow-x: auto; padding: 8px 0 0; scrollbar-width: thin; }
.cpcv-indice button { flex: none; background: none; border: none; border-bottom: 2px solid transparent; color: #5B6272; padding: 8px 12px; font-size: 13.5px; font-weight: 600; cursor: pointer; font-family: inherit; }
.cpcv-indice button:hover { color: #0B1B3D; border-bottom-color: #0B1B3D; }
.cpcv-indice { align-items: center; gap: 2px; padding: 10px 0 8px; }
.cpcv-indice .cpcv-passo { display: inline-flex; align-items: center; gap: 8px; border: none; border-bottom: none; background: none; padding: 4px 8px; border-radius: 10px; }
.cpcv-indice .cpcv-passo:hover { background: #E7EBF3; border-bottom: none; }
.cpcv-bola { width: 26px; height: 26px; border-radius: 50%; display: inline-grid; place-items: center; font-size: 12.5px; font-weight: 700; background: #fff; border: 2px solid #C9CED8; color: #5B6272; flex: none; }
.cpcv-passo.ok .cpcv-bola { background: #067647; border-color: #067647; color: #fff; }
.cpcv-passo.ativo .cpcv-bola { background: linear-gradient(90deg, #0B1B3D 0%, #1E3566 45%, #4A6BA8 100%); border-color: #1E3566; color: #fff; }
.cpcv-passo.ativo { background: #E7EBF3; }
.cpcv-passo-t { color: #5B6272; font-size: 13.5px; font-weight: 600; text-align: left; line-height: 1.2; }
.cpcv-passo.ativo .cpcv-passo-t { color: #0B1B3D; }
.cpcv-passo-t small { display: block; font-size: 11.5px; font-weight: 500; color: #5B6272; margin-top: 1px; }
.cpcv-liga { flex: 1 1 10px; min-width: 8px; max-width: 28px; height: 2px; background: #E3E6EC; border-radius: 2px; }
.cpcv-indice .cpcv-esc { margin-left: auto; color: #1E3566; display: inline-flex; align-items: center; gap: 6px; border: 1.5px solid #1E3566; border-radius: 8px; padding: 6px 12px; background: #fff; }
.cpcv-indice .cpcv-esc:hover { background: #E7EBF3; }
.cpcv-indice .cpcv-esc[aria-current="step"] { background: #1E3566; color: #fff; }
.cpcv-prog { display: flex; align-items: center; gap: 12px; padding-top: 10px; }
.cpcv-prog-t { font-size: 12.5px; font-weight: 600; color: #5B6272; white-space: nowrap; font-variant-numeric: tabular-nums; }
.cpcv-prog-b { flex: 1; height: 6px; background: #E3E6EC; border-radius: 99px; overflow: hidden; }
.cpcv-prog-b > div { height: 100%; background: linear-gradient(90deg, #0B1B3D 0%, #1E3566 45%, #4A6BA8 100%); border-radius: 99px; transition: width .3s; }
.cpcv-pulsar { outline: 2px solid #1E3566 !important; box-shadow: 0 0 0 5px rgba(74,107,168,0.35) !important; }
@media (max-width: 640px) {
  .cpcv-form [style*="grid-template-columns: 1fr 1fr"], .cpcv-form [style*="grid-template-columns: 3fr 1fr"] { grid-template-columns: 1fr !important; }
  .cpcv-cab-id { display: none !important; }
}
@media (prefers-reduced-motion: reduce) { .cpcv-form * { scroll-behavior: auto !important; transition: none !important; } }
`;

export function F({ label, value, onChange, type = "text", placeholder = "", opcoes = null, destacar = false, bloqueado = false, erro = "" }) {
  const uid = useId();
  // bloqueado: o campo vem da angariação e edita-se na angariação (🔒)
  const inputStyle = bloqueado ? { ...S.input, background:"#F4F6FA", color:"#5B6272", cursor:"not-allowed" }
    : destacar ? { ...S.input, background:"#F4F6FA" } : S.input;
  const lbl = bloqueado ? <>{label} <span title="Vem da angariação: edita-se na angariação" style={{ color:"#9AA1AE", marginLeft:4, verticalAlign:"middle" }}><Lock size={12} aria-hidden="true" /></span></>
    : destacar ? <>{label} <span title="Pré-preenchido pela angariação, editável" style={{ background:"#E7EBF3", color:"#0B1B3D", borderRadius:4, padding:"0 6px", fontSize:11, fontWeight:600, marginLeft:4 }}>da angariação</span></> : label;
  if (opcoes) return (
    <div>
      <label htmlFor={uid} style={S.label}>{lbl}</label>
      <select id={uid} aria-invalid={!!erro} value={value} onChange={e => onChange(e.target.value)} style={inputStyle} disabled={bloqueado}>
        <option value="">Selecionar...</option>
        {opcoes.map(o => <option key={o.value||o} value={o.value||o}>{o.label||o}</option>)}
      </select>
      {erro && <div role="alert" style={{ fontSize: 12, color: "#B42318", marginTop: 4 }}>{erro}</div>}
    </div>
  );
  return (
    <div>
      <label htmlFor={uid} style={S.label}>{lbl}</label>
      <input id={uid} aria-invalid={!!erro} type={type} value={value} onChange={e => onChange(e.target.value)} placeholder={placeholder} style={inputStyle} disabled={bloqueado} />
      {erro && <div role="alert" style={{ fontSize: 12, color: "#B42318", marginTop: 4 }}>{erro}</div>}
    </div>
  );
}

function BlocoIdentidade({ d, onChange }) {
  const s = (k, v) => onChange({ ...d, [k]: v });
  const sc = (k, v) => onChange({ ...d, conjuge: { ...(d.conjuge||{}), [k]: v } });
  return (
    <div>
      <div style={{ ...S.gNome, marginBottom: 12 }}>
        <F label="Nome completo" value={d.nome} onChange={v => s("nome", v)} />
        <F label="NIF" value={d.nif} onChange={v => s("nif", v)} />
      </div>
      <div style={{ ...S.g3, marginBottom: 12 }}>
        <F label="CC / BI / Passaporte" value={d.cc} onChange={v => s("cc", v)} />
        <F label="Validade / Emissão" value={d.validade_cc} onChange={v => s("validade_cc", v)} type="date" />
        <F label="Naturalidade" value={d.naturalidade} onChange={v => s("naturalidade", v)} />
      </div>
      <div style={{ ...S.g3, marginBottom: 12 }}>
        <F label="Telefone" value={d.telefone} onChange={v => s("telefone", v)} />
        <F label="Email" value={d.email} onChange={v => s("email", v)} type="email" />
        <F label="Estado Civil" value={d.estado_civil} onChange={v => s("estado_civil", v)} opcoes={ESTADO_CIVIL_OPS} />
      </div>
      <div style={{ ...S.gMorada, marginBottom: 0 }}>
        <F label="Morada" value={d.morada} onChange={v => s("morada", v)} />
        <F label="Código Postal" value={d.codigo_postal} onChange={v => s("codigo_postal", v)} placeholder="0000-000" />
      </div>
      {d.estado_civil === "Casado(a)" && (
        <div style={{ marginTop: 12 }}>
          <div style={S.g2}>
            <F label="Regime de casamento" value={d.regime_casamento} onChange={v => s("regime_casamento", v)} opcoes={REGIME_CASAMENTO_OPS} />
            <div>
              <label style={S.label}>Casou em Portugal?</label>
              <div style={{ display: "flex", gap: 12, marginTop: 6 }}>
                {[true, false].map(v => (
                  <label key={String(v)} style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 13, cursor: "pointer" }}>
                    <input type="radio" checked={d.casou_portugal === v} onChange={() => s("casou_portugal", v)} />{v ? "Sim" : "Não"}
                  </label>
                ))}
              </div>
            </div>
          </div>
          {d.casou_portugal === false && <div style={{ marginTop: 10 }}><F label="País / Estado onde casou" value={d.pais_casamento} onChange={v => s("pais_casamento", v)} /></div>}
          <div style={S.sub}>
            <div style={{ fontWeight: 600, fontSize: 12, color: "#6b7280", marginBottom: 10 }}>CÔNJUGE</div>
            <div style={{ ...S.gNome, marginBottom: 10 }}>
              <F label="Nome" value={d.conjuge?.nome||""} onChange={v => sc("nome", v)} />
              <F label="NIF" value={d.conjuge?.nif||""} onChange={v => sc("nif", v)} />
            </div>
            <div style={{ ...S.g3, marginBottom: 10 }}>
              <F label="CC / BI / Passaporte" value={d.conjuge?.cc||""} onChange={v => sc("cc", v)} />
              <F label="Validade" value={d.conjuge?.validade_cc||""} onChange={v => sc("validade_cc", v)} type="date" />
              <F label="Naturalidade" value={d.conjuge?.naturalidade||""} onChange={v => sc("naturalidade", v)} />
            </div>
            <div style={S.g2}>
              <F label="Telefone" value={d.conjuge?.telefone||""} onChange={v => sc("telefone", v)} />
              <F label="Email" value={d.conjuge?.email||""} onChange={v => sc("email", v)} type="email" />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function BlocoProcuradores({ lista, onChange }) {
  const add = () => onChange([...lista, procuradorVazio()]);
  const rem = i => onChange(lista.filter((_, xi) => xi !== i));
  const upd = (i, k, v) => onChange(lista.map((p, xi) => xi === i ? { ...p, [k]: v } : p));
  return (
    <div style={{ marginTop: 10 }}>
      {lista.map((p, i) => (
        <div key={i} style={{ ...S.sub, marginBottom: 8 }}>
          <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 10 }}>
            <span style={{ fontWeight: 600, fontSize: 12, color: "#6b7280" }}>PROCURADOR {i+1}</span>
            <button onClick={() => rem(i)} style={S.btnRem}>Remover</button>
          </div>
          <div style={{ ...S.gNome, marginBottom: 10 }}>
            <F label="Nome" value={p.nome} onChange={v => upd(i,"nome",v)} />
            <F label="NIF" value={p.nif} onChange={v => upd(i,"nif",v)} />
          </div>
          <div style={{ ...S.g3, marginBottom: 10 }}>
            <F label="CC / BI / Passaporte" value={p.cc} onChange={v => upd(i,"cc",v)} />
            <F label="Validade" value={p.validade_cc} onChange={v => upd(i,"validade_cc",v)} type="date" />
            <F label="Naturalidade" value={p.naturalidade} onChange={v => upd(i,"naturalidade",v)} />
          </div>
          <div style={{ ...S.g3, marginBottom: 10 }}>
            <F label="Telefone" value={p.telefone} onChange={v => upd(i,"telefone",v)} />
            <F label="Email" value={p.email} onChange={v => upd(i,"email",v)} type="email" />
            <F label="Estado Civil" value={p.estado_civil} onChange={v => upd(i,"estado_civil",v)} opcoes={ESTADO_CIVIL_OPS} />
          </div>
          <div style={S.gMorada}>
            <F label="Morada" value={p.morada} onChange={v => upd(i,"morada",v)} />
            <F label="Código Postal" value={p.codigo_postal||""} onChange={v => upd(i,"codigo_postal",v)} placeholder="0000-000" />
          </div>
        </div>
      ))}
      <button onClick={add} style={S.btnAdd}>+ Adicionar Procurador</button>
    </div>
  );
}

function BlocoParticipante({ p, i, tipoLabel, onChange, onRemove, showRemove }) {
  const upd = dados => onChange(i, dados);
  const updProc = lista => onChange(i, { ...p, procuradores: lista });
  return (
    <div style={{ ...S.sub, marginBottom: 14 }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <span style={{ fontWeight: 700, fontSize: 13 }}>{tipoLabel} {i+1}</span>
          <span style={{ background: p.tipo==="particular"?"#eff6ff":p.tipo==="heranca"?"#faf5ff":"#f0fdf4", color: p.tipo==="particular"?"#3b82f6":p.tipo==="heranca"?"#8b5cf6":"#10b981", borderRadius: 20, padding: "2px 10px", fontSize: 11, fontWeight: 600 }}>
            {p.tipo==="particular"?"Particular":p.tipo==="heranca"?"Herança":"Empresa"}
          </span>
        </div>
        {showRemove && <button onClick={onRemove} style={S.btnRem}>Remover</button>}
      </div>
      {p.tipo === "particular" && (
        <div>
          <BlocoIdentidade d={p} onChange={dados => upd({ ...dados, tipo:"particular", autorizantes: p.autorizantes, procuradores: p.procuradores })} />
          {p.estado_civil === "Casado(a)" && (
            <div style={{ marginTop: 12 }}>
              <div style={{ fontSize: 12, fontWeight: 600, color: "#6b7280", marginBottom: 6 }}>AUTORIZANTES (quando aplicável)</div>
              {(p.autorizantes||[]).map((a, ai) => (
                <div key={ai} style={{ ...S.sub, marginBottom: 8 }}>
                  <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 8 }}>
                    <span style={{ fontWeight: 600, fontSize: 12 }}>Autorizante {ai+1}</span>
                    <button onClick={() => upd({ ...p, autorizantes: p.autorizantes.filter((_,xi)=>xi!==ai) })} style={S.btnRem}>Remover</button>
                  </div>
                  <div style={S.gNome}>
                    <F label="Nome" value={a.nome} onChange={v => upd({ ...p, autorizantes: p.autorizantes.map((x,xi)=>xi===ai?{...x,nome:v}:x) })} />
                    <F label="NIF" value={a.nif||""} onChange={v => upd({ ...p, autorizantes: p.autorizantes.map((x,xi)=>xi===ai?{...x,nif:v}:x) })} />
                  </div>
                </div>
              ))}
              <button onClick={() => upd({ ...p, autorizantes: [...(p.autorizantes||[]), { nome:"", nif:"" }] })} style={S.btnAdd}>+ Adicionar Autorizante</button>
            </div>
          )}
          <div style={{ marginTop: 12 }}>
            <div style={{ fontSize: 12, fontWeight: 600, color: "#6b7280", marginBottom: 4 }}>PROCURADORES (quando aplicável)</div>
            <BlocoProcuradores lista={p.procuradores||[]} onChange={updProc} />
          </div>
        </div>
      )}
      {p.tipo === "heranca" && (
        <div>
          <F label="Identificação da Herança" value={p.nome_heranca} onChange={v => upd({ ...p, nome_heranca: v })} />
          <div style={{ marginTop: 14 }}>
            <div style={{ fontSize: 12, fontWeight: 600, color: "#6b7280", marginBottom: 8 }}>HERDEIROS</div>
            {(p.herdeiros||[]).map((h, hi) => (
              <div key={hi} style={{ ...S.sub, marginBottom: 10 }}>
                <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 10 }}>
                  <span style={{ fontWeight: 700, fontSize: 12.5 }}>Herdeiro {hi+1}</span>
                  {p.herdeiros.length > 1 && <button onClick={() => upd({ ...p, herdeiros: p.herdeiros.filter((_,xi)=>xi!==hi) })} style={S.btnRem}>Remover</button>}
                </div>
                <BlocoIdentidade d={h} onChange={dados => upd({ ...p, herdeiros: p.herdeiros.map((x,xi)=>xi===hi?dados:x) })} />
              </div>
            ))}
            <button onClick={() => upd({ ...p, herdeiros: [...p.herdeiros, pessoaVazia()] })} style={S.btnAdd}>+ Adicionar Herdeiro</button>
          </div>
          <div style={{ marginTop: 12 }}>
            <div style={{ fontSize: 12, fontWeight: 600, color: "#6b7280", marginBottom: 6 }}>AUTORIZANTES (quando aplicável)</div>
            {(p.autorizantes||[]).map((a, ai) => (
              <div key={ai} style={{ ...S.sub, marginBottom: 8 }}>
                <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 8 }}>
                  <span style={{ fontWeight: 600, fontSize: 12 }}>Autorizante {ai+1}</span>
                  <button onClick={() => upd({ ...p, autorizantes: p.autorizantes.filter((_,xi)=>xi!==ai) })} style={S.btnRem}>Remover</button>
                </div>
                <div style={S.gNome}>
                  <F label="Nome" value={a.nome} onChange={v => upd({ ...p, autorizantes: p.autorizantes.map((x,xi)=>xi===ai?{...x,nome:v}:x) })} />
                  <F label="NIF" value={a.nif||""} onChange={v => upd({ ...p, autorizantes: p.autorizantes.map((x,xi)=>xi===ai?{...x,nif:v}:x) })} />
                </div>
              </div>
            ))}
            <button onClick={() => upd({ ...p, autorizantes: [...(p.autorizantes||[]), { nome:"", nif:"" }] })} style={S.btnAdd}>+ Adicionar Autorizante</button>
          </div>
          <div style={{ marginTop: 12 }}>
            <div style={{ fontSize: 12, fontWeight: 600, color: "#6b7280", marginBottom: 4 }}>PROCURADORES (quando aplicável)</div>
            <BlocoProcuradores lista={p.procuradores||[]} onChange={updProc} />
          </div>
        </div>
      )}
      {p.tipo === "empresa" && (
        <div>
          <div style={{ ...S.gNome, marginBottom: 12 }}>
            <F label="Nome da Empresa" value={p.nome_empresa} onChange={v => upd({ ...p, nome_empresa: v })} />
            <F label="NIPC" value={p.nipc} onChange={v => upd({ ...p, nipc: v })} />
          </div>
          <div style={{ ...S.gMorada, marginBottom: 12 }}>
            <F label="Morada da Sede" value={p.morada_sede} onChange={v => upd({ ...p, morada_sede: v })} />
            <F label="Código Postal" value={p.codigo_postal_sede||""} onChange={v => upd({ ...p, codigo_postal_sede: v })} placeholder="0000-000" />
          </div>
          <div style={{ marginBottom: 12 }}>
            <label style={S.label}>CAE inclui Compra e Venda de Imóveis?</label>
            <div style={{ display: "flex", gap: 16, marginTop: 6 }}>
              {[{ v: true, l:"Sim" }, { v: false, l:"Não" }].map(({ v, l }) => (
                <label key={l} style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 13, cursor: "pointer" }}>
                  <input type="radio" checked={p.tem_cae_imoveis===v} onChange={() => upd({ ...p, tem_cae_imoveis: v })} />{l}
                </label>
              ))}
            </div>
          </div>
          {p.tem_cae_imoveis === false && (
            <div style={{ marginBottom: 12 }}>
              <label style={S.label}>Autorização</label>
              <div style={{ display: "flex", gap: 16, marginTop: 6 }}>
                {[{ v:"ata", l:"Ata da empresa" }, { v:"todos_socios", l:"Todos os sócios assinam" }].map(({ v, l }) => (
                  <label key={v} style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 13, cursor: "pointer" }}>
                    <input type="radio" checked={p.ata_ou_socios===v} onChange={() => upd({ ...p, ata_ou_socios: v })} />{l}
                  </label>
                ))}
              </div>
            </div>
          )}
          <div style={{ marginTop: 6 }}>
            <div style={{ fontSize: 12, fontWeight: 600, color: "#6b7280", marginBottom: 8 }}>GERENTES / ADMINISTRADORES</div>
            {(p.gerentes||[]).map((g, gi) => (
              <div key={gi} style={{ ...S.sub, marginBottom: 10 }}>
                <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 10 }}>
                  <span style={{ fontWeight: 700, fontSize: 12.5 }}>Gerente {gi+1}</span>
                  {p.gerentes.length > 1 && <button onClick={() => upd({ ...p, gerentes: p.gerentes.filter((_,xi)=>xi!==gi) })} style={S.btnRem}>Remover</button>}
                </div>
                <div style={{ ...S.gNome, marginBottom: 10 }}>
                  <F label="Nome" value={g.nome} onChange={v => upd({ ...p, gerentes: p.gerentes.map((x,xi)=>xi===gi?{...x,nome:v}:x) })} />
                  <F label="NIF" value={g.nif} onChange={v => upd({ ...p, gerentes: p.gerentes.map((x,xi)=>xi===gi?{...x,nif:v}:x) })} />
                </div>
                <div style={{ ...S.g3, marginBottom: 10 }}>
                  <F label="CC / BI / Passaporte" value={g.cc} onChange={v => upd({ ...p, gerentes: p.gerentes.map((x,xi)=>xi===gi?{...x,cc:v}:x) })} />
                  <F label="Validade" value={g.validade_cc} onChange={v => upd({ ...p, gerentes: p.gerentes.map((x,xi)=>xi===gi?{...x,validade_cc:v}:x) })} type="date" />
                  <F label="Naturalidade" value={g.naturalidade} onChange={v => upd({ ...p, gerentes: p.gerentes.map((x,xi)=>xi===gi?{...x,naturalidade:v}:x) })} />
                </div>
                <div style={{ ...S.g3, marginBottom: 10 }}>
                  <F label="Telefone" value={g.telefone} onChange={v => upd({ ...p, gerentes: p.gerentes.map((x,xi)=>xi===gi?{...x,telefone:v}:x) })} />
                  <F label="Email" value={g.email} onChange={v => upd({ ...p, gerentes: p.gerentes.map((x,xi)=>xi===gi?{...x,email:v}:x) })} type="email" />
                  <F label="Estado Civil" value={g.estado_civil} onChange={v => upd({ ...p, gerentes: p.gerentes.map((x,xi)=>xi===gi?{...x,estado_civil:v}:x) })} opcoes={ESTADO_CIVIL_OPS} />
                </div>
                <F label="Residência" value={g.residencia} onChange={v => upd({ ...p, gerentes: p.gerentes.map((x,xi)=>xi===gi?{...x,residencia:v}:x) })} />
              </div>
            ))}
            <button onClick={() => upd({ ...p, gerentes: [...p.gerentes, { nome:"",naturalidade:"",cc:"",validade_cc:"",nif:"",telefone:"",email:"",estado_civil:"",residencia:"" }] })} style={S.btnAdd}>+ Adicionar Gerente</button>
          </div>
          <div style={{ marginTop: 12 }}>
            <div style={{ fontSize: 12, fontWeight: 600, color: "#6b7280", marginBottom: 4 }}>PROCURADORES (quando aplicável)</div>
            <BlocoProcuradores lista={p.procuradores||[]} onChange={updProc} />
          </div>
        </div>
      )}
    </div>
  );
}

// participante a partir de um contacto (fica ligado ao contacto pelo lead_id)
export function participanteDeContacto(l) {
  return { ...partVazio(), lead_id: l.id, nome: l.nome_completo || l.nome || "", nif: l.nif || "", cc: l.cc || "", validade_cc: l.validade_cc || "",
    telefone: l.telefone || "", email: l.email || "", estado_civil: l.estado_civil || "", regime_casamento: l.regime_casamento || "",
    naturalidade: l.naturalidade || "", morada: l.morada || "", codigo_postal: l.codigo_postal || "" };
}
const semNome = (p) => !p || (!p.nome && !p.nome_empresa && !p.nome_heranca);
export function SecaoParticipantes({ lista, onChange, tipoLabel, contactos = null }) {
  const [procurar, setProcurar] = useState(false), [q, setQ] = useState("");
  const qn = q.trim().toLowerCase();
  const encontrados = !qn ? [] : (contactos || []).filter(l => !l.deleted_at && [l.nome, l.nome_completo, l.telefone, l.email, l.nif].some(v => String(v || "").toLowerCase().includes(qn))).slice(0, 8);
  const escolher = (l) => {
    const novo = participanteDeContacto(l);
    // substitui o primeiro participante ainda vazio; senão acrescenta
    const i = lista.findIndex(semNome);
    onChange(i >= 0 ? lista.map((p, xi) => (xi === i ? novo : p)) : [...lista, novo]);
    setProcurar(false); setQ("");
  };
  const add = tipo => {
    if (tipo==="particular") onChange([...lista, partVazio()]);
    else if (tipo==="heranca") onChange([...lista, herancaVazia()]);
    else onChange([...lista, empresaVazia()]);
  };
  const rem = i => onChange(lista.filter((_,xi)=>xi!==i));
  const upd = (i, dados) => onChange(lista.map((p,xi)=>xi===i?dados:p));
  return (
    <div>
      {lista.map((p, i) => (
        <div key={i}>
          {p?.lead_id && <div style={{ fontSize: 11.5, color: "#1e3a7a", fontWeight: 600, margin: "0 0 4px" }}>🔗 Ligado ao contacto {(contactos || []).find(l => l.id === p.lead_id)?.codigo || ""}</div>}
          <BlocoParticipante p={p} i={i} tipoLabel={tipoLabel} onChange={upd} onRemove={() => rem(i)} showRemove={lista.length > 1} />
        </div>
      ))}
      <div style={{ display: "flex", gap: 8, marginTop: 4, flexWrap: "wrap" }}>
        {contactos && <button type="button" onClick={() => setProcurar(v => !v)} style={{ ...S.btnAdd, flex: 1, borderColor: "#1e3a7a", color: "#1e3a7a", fontWeight: 700 }}>👤 Escolher contacto</button>}
        <button onClick={() => add("particular")} style={{ ...S.btnAdd, flex: 1 }}>+ Particular</button>
        <button onClick={() => add("heranca")} style={{ ...S.btnAdd, flex: 1 }}>+ Herança</button>
        <button onClick={() => add("empresa")} style={{ ...S.btnAdd, flex: 1 }}>+ Empresa</button>
      </div>
      {procurar && (
        <div style={{ marginTop: 8, border: "1.5px solid #d6deef", borderRadius: 10, padding: 10, background: "#f8f9fc" }}>
          <input autoFocus value={q} onChange={e => setQ(e.target.value)} placeholder={`Procurar o ${tipoLabel.toLowerCase()} nos contactos (nome, telefone, email ou NIF)`} aria-label={`Procurar contacto do ${tipoLabel.toLowerCase()}`} style={{ ...S.input, marginBottom: 6 }} />
          {qn && !encontrados.length && <div style={{ fontSize: 12, color: "#8a909d" }}>Nenhum contacto encontrado. Use "+ Particular", "+ Herança" ou "+ Empresa" para preencher à mão.</div>}
          {encontrados.map(l => (
            <button type="button" key={l.id} onClick={() => escolher(l)} style={{ display: "flex", width: "100%", justifyContent: "space-between", gap: 8, background: "#fff", border: "1px solid #e6e3dc", borderRadius: 8, padding: "7px 10px", marginBottom: 4, cursor: "pointer", fontSize: 12.5, textAlign: "left" }}>
              <span><b>{l.nome_completo || l.nome}</b>{l.codigo ? <span style={{ color: "#8a909d" }}> · {l.codigo}</span> : null}</span><span style={{ color: "#8a909d" }}>{l.telefone || l.email || ""}</span>
            </button>))}
        </div>)}
    </div>
  );
}

export default function FormCPCV({ supabase, profile, isLider, user, leads, consultores, angariações=[], fetchAngariações, formulario, onVoltar, modoEscritura, onNegocioCriado, criarNotificacao, pedirConfirmacaoComissao, onCancelarProcesso, onAbrirAngariacao, irParaPedido }) {
  const isEd = !!formulario;
  const [agencia, setAgencia] = useState(formulario?.agencia||"white");
  const [angariacaoTipo, setAngariacaoTipo] = useState(() => {
    if (!formulario) return "interna";
    // Retro: se BD tem 'interna' SEM partilha_colega, é na verdade Pleno
    if (formulario.angariacao_tipo === "interna" && !formulario.partilha_colega) return "pleno";
    return formulario.angariacao_tipo || "interna";
  });
  const [leadId, setLeadId] = useState(formulario?.lead_id||"");
  const [leadIdVendedor, setLeadIdVendedor] = useState(formulario?.lead_id_vendedor||"");
  const [leadIdComprador, setLeadIdComprador] = useState(formulario?.lead_id_comprador||"");
  // Lider/admin pode preencher o formulário em nome de outro consultor
  const [agenteEscolhidoId, setAgenteEscolhidoId] = useState(formulario?.agente_id || profile?.id || "");
  const consultorEscolhido = (consultores||[]).find(c => c.id === agenteEscolhidoId) || profile;
  const consNome = consultorEscolhido?.nome || profile?.nome || "";
  const consId = consultorEscolhido?.id || profile?.id || null;
  const isLiderPreenchendoOutro = isLider && consId !== profile?.id;

  // Popula o 1º participante com os dados da lead seleccionada (vendedor ou comprador)
  const aplicarLead = (leadIdSel, tipo) => {
    if (!leadIdSel) return;
    const lead = (leads||[]).find(l => String(l.id) === String(leadIdSel));
    if (!lead) return;
    const lista = tipo === "vendedor" ? vendedores : compradores;
    const setter = tipo === "vendedor" ? setVendedores : setCompradores;
    const primeiro = lista[0] || partVazio();
    const nomeLead = lead.nome_completo || lead.nome || "";
    if (primeiro.tipo === "particular" && primeiro.nome && primeiro.nome.toLowerCase() !== nomeLead.toLowerCase()) {
      if (!window.confirm(`Substituir os dados de "${primeiro.nome}" pelos da lead "${nomeLead}"?`)) return;
    }
    const novoPrim = {
      ...partVazio(),
      tipo: "particular",
      nome: nomeLead,
      nif: lead.nif || "",
      cc: lead.cc || "",
      validade_cc: lead.validade_cc || "",
      naturalidade: lead.naturalidade || "",
      telefone: lead.telefone || "",
      email: lead.email || "",
      estado_civil: lead.estado_civil || "",
      morada: lead.morada || "",
      codigo_postal: lead.codigo_postal || "",
    };
    setter([novoPrim, ...lista.slice(1)]);
  };
  const [refImovel, setRefImovel] = useState(formulario?.ref_imovel||"");
  const [erros, setErros] = useState({});
  const [angariacaoLigada, setAngariacaoLigada] = useState(null);
  const [mostrarCriarAng, setMostrarCriarAng] = useState(false);
  // Tracking de campos pré-preenchidos pela angariação (para destaque visual azul + badge 📦)
  const [camposPreAng, setCamposPreAng] = useState(new Set());
  const fromAng = (k) => camposPreAng.has(k);
  // angariação nossa ligada: os campos do imóvel que vêm dela ficam bloqueados (editam-se na angariação)
  const angHeranca = angariacaoTipo !== "externa" ? angariacaoLigada : null;
  const bloqImovel = (k) => herdado(angHeranca, k, "cpcv");
  useEffect(() => {
    if (!angHeranca) return;
    const vazios = diferencas(imoveis[0] || {}, angHeranca, "cpcv").filter(d => !String(d.atual || "").trim());
    if (vazios.length) setImoveis(lista => { const im0 = { ...(lista[0] || {}) }; vazios.forEach(d => { im0[d.campo] = d.angariacao; }); return [im0, ...lista.slice(1)]; });
  }, [angHeranca?.id]); // eslint-disable-line react-hooks/exhaustive-deps
  const styleFromAng = (k, baseStyle) => fromAng(k) ? { ...baseStyle, background:"#eff6ff", borderColor:"#bfdbfe", boxShadow:"inset 0 0 0 1px #bfdbfe" } : baseStyle;
  const labelFromAng = (label, k) => fromAng(k) ? <>{label} <span title="Pré-preenchido pela angariação" style={{ background:"#dbeafe", color:"#1e40af", borderRadius:4, padding:"0 5px", fontSize:9, fontWeight:700, marginLeft:4 }}>📦</span></> : label;
  // Se vem do AgendarEscrituraSelector com angariação pré-seleccionada
  useEffect(() => {
    if (!formulario && modoEscritura === "agendamento") {
      const refSession = sessionStorage.getItem("agendar_ref_angariacao");
      if (refSession) {
        setRefImovel(refSession);
        sessionStorage.removeItem("agendar_ref_angariacao");
        // Vai disparar puxarDaAngariacao via useEffect abaixo
      }
    }
  }, [formulario, modoEscritura]);
  // Auto-popular quando refImovel muda E há angariações disponíveis
  useEffect(() => {
    if (refImovel && (angariações||[]).length > 0) {
      const ang = angariações.find(a => a.id_angariacao?.toLowerCase() === refImovel.toLowerCase());
      if (ang && (!angariacaoLigada || angariacaoLigada.id !== ang.id)) {
        // Auto-popular silenciosamente (sem prompt de vendedores se ainda não há nada)
        setAngariacaoLigada(ang);
      }
    }
  }, [refImovel, angariações]);
  const [papelAgente, setPapelAgente] = useState(formulario?.papel_agente||"angariador");
  const [partilhaColega, setPartilhaColega] = useState(formulario?.partilha_colega||"");
  const [agExtPartilha, setAgExtPartilha] = useState(formulario?.agencia_externa_partilha||{ nome:"", agente:"" });
  const [tipoImovelChecklist, setTipoImovelChecklist] = useState(formulario?.tipo_imovel_checklist||"");
  const [tipoTitular, setTipoTitular] = useState(formulario?.tipo_titular||"individual_nacional");
  const [imoveis, setImoveis] = useState(formulario?.imoveis?.length ? formulario.imoveis : [imovelVazio()]);
  const [agExtAngariadora, setAgExtAngariadora] = useState(formulario?.agencia_externa||{ nome:"", agente:"", telefone:"", email:"" });
  const [vendedores, setVendedores] = useState(formulario?.vendedores_promitentes||[partVazio()]);
  const [compradores, setCompradores] = useState(formulario?.proponentes||[partVazio()]);
  const [checklist, setChecklist] = useState(formulario?.checklist_documentos||[]);
  const [prazoTipo, setPrazoTipo] = useState(formulario?.prazo_tipo||"data");
  const [condicoes, setCondicoes] = useState({
    forma_pagamento_sinal: formulario?.forma_pagamento_sinal||"",
    quem_marca_escritura: formulario?.quem_marca_escritura||"",
    prazo_escritura: formulario?.prazo_escritura||"",
    prazo_dias: formulario?.prazo_dias||"",
    recurso_credito: formulario?.recurso_credito||false,
    banco_credito: formulario?.banco_credito||"",
    valor_a_financiar: formulario?.valor_a_financiar||"",  // valor que o comprador vai pedir ao banco (na escritura compara-se com o financiado)
    responsavel_financiamento: formulario?.responsavel_financiamento||"",
    financiamento_100pct: formulario?.financiamento_100pct||false,
    clausula_aprovacao: formulario?.clausula_aprovacao||false,
    clausula_avaliacao: formulario?.clausula_avaliacao||false,
    habitacao: formulario?.habitacao||"",
    iban_sinal: formulario?.iban_sinal||"",          // IBAN do vendedor (recebe o sinal)
    iban_comprador: formulario?.iban_comprador||"",  // IBAN do comprador (paga o sinal)
    outras_condicoes: formulario?.outras_condicoes||"",
    data_assinatura_cpcv: formulario?.data_assinatura_cpcv||"",
    data_assinatura_confirmada: formulario?.data_assinatura_confirmada||"",
    tem_aditamento: formulario?.tem_aditamento||false,
    adit_valor_venda: formulario?.adit_valor_venda||"",
    adit_valor_sinal: formulario?.adit_valor_sinal||"",
    adit_valor_reforco: formulario?.adit_valor_reforco||"",
    adit_data_reforco: formulario?.adit_data_reforco||"",
    adit_prazo_dias: formulario?.adit_prazo_dias||"",
    adit_data_escritura: formulario?.adit_data_escritura||"",
    adit_clausulas: formulario?.adit_clausulas||"",
  });
  const [escrituraDirecta, setEscrituraDirecta] = useState(formulario?.escritura_directa || modoEscritura==="directa" || false);
  const [escrituraData, setEscrituraData] = useState(formulario?.escritura_data||"");
  const [escrituraHora, setEscrituraHora] = useState(formulario?.escritura_hora||"");
  const [escrituraLocal, setEscrituraLocal] = useState(formulario?.escritura_local||"");
  const [escrituraNotas, setEscrituraNotas] = useState(formulario?.escritura_notas||"");
  // Motivo (só relevante quando escrituraDirecta=true)
  const [escDiretaMotivo, setEscDiretaMotivo] = useState(formulario?.escritura_directa_motivo||"");
  const [escDiretaMotivoOutro, setEscDiretaMotivoOutro] = useState(formulario?.escritura_directa_motivo_outro||"");
  // Notário (novo)
  const [notarioNome, setNotarioNome] = useState(formulario?.notario_nome||"");
  const [notarioMorada, setNotarioMorada] = useState(formulario?.notario_morada||"");
  // entidade da escritura (Cartório, Solicitador, Advogado, Plataforma Legal, Outro) — substitui o antigo campo "Local"
  const [entidade, setEntidade] = useState({ tipo: formulario?.entidade_tipo || "", id: formulario?.entidade_id || null, nome: formulario?.escritura_local || "" });
  const [notarioTelefone, setNotarioTelefone] = useState(formulario?.notario_telefone||"");
  const [saving, setSaving] = useState(false);
  const [secAberta, setSecAberta] = useState({ imoveis:true, vendedores:true, compradores:true, condicoes:true, documentos:true, docsnegocio:true });
  // fase do formulário que está no ecrã (uma de cada vez); "escritura" só abre pelo botão próprio ou ao chegar pelo Agendar escritura
  const [fase, setFase] = useState(modoEscritura === "agendamento" ? "escritura" : modoEscritura === "prazo" ? "condicoes" : "cabecalho");
  const vis = (...ids) => (ids.includes(fase) ? {} : { display: "none" });
  useEffect(() => {
    if (modoEscritura === "prazo") {
      setTimeout(() => {
        const el = document.getElementById("data-limite-escritura");
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "center" });
          el.style.transition = "box-shadow 0.5s";
          el.style.boxShadow = "0 0 0 4px #fbbf24, 0 0 20px rgba(245,158,11,0.4)";
          setTimeout(() => { el.style.boxShadow = ""; }, 2500);
        }
      }, 400);
    }
  }, [modoEscritura]);
  useEffect(() => { setErros({}); }, [refImovel, escDiretaMotivo, escDiretaMotivoOutro, escrituraData]);
  const toggleSec = () => {};
  // Índice no topo: abre o bloco (se estiver fechado) e desce até ele.
  const irPara = (id, k) => {
    if (k) setSecAberta(s => (s[k] ? s : { ...s, [k]: true }));
    const f = FASE_DE_SEC[id];
    if (f) setFase(f);
    setTimeout(() => { const el = f ? document.querySelector(".cpcv-cab") : document.getElementById(id); if (el && el.scrollIntoView) el.scrollIntoView({ behavior: "smooth", block: "start" }); }, 60);
  };
  const SecTitulo = ({k, icon, label, semBarra}) => {
    const Ic = ICONES_SEC[icon];
    const estiloBarra = semBarra ? { flex:1, padding:"0" } : { ...S.barra, margin: secAberta[k] ? "-20px -24px 16px" : "-20px -24px -20px", borderRadius: secAberta[k] ? "11px 11px 0 0" : 11 };
    return (
      <div style={{ display:"flex", alignItems:"center", justifyContent:"space-between", ...estiloBarra }}>
        <div style={{ fontWeight:600, fontSize:16, color:"#fff", display:"flex", alignItems:"center", gap:8 }}>{Ic ? <Ic size={18} aria-hidden="true" style={{ color:"#fff" }} /> : null} {label}</div>
      </div>
    );
  };
  const [docsNegocio, setDocsNegocio] = useState(formulario?.docs_negocio || [
    { id: "cpcv", label: "CPCV Assinado", path: formulario?.documento_assinado_path || "" },
    { id: "escritura", label: "Escritura / Documento Final", path: formulario?.documento_escritura_path || "" },
  ]);
  const [pdfModal, setPdfModal] = useState(false);
  const [pdfOpcaoId, setPdfOpcaoId] = useState("tudo");
  const [pdfOpcoes, setPdfOpcoes] = useState({ cabecalho:true, imoveis:true, vendedores:true, compradores:true, condicoes:true, documentos:false });

  function construirHtmlPdf(opcoes) {
    const vv = Number(condicoes.adit_valor_venda||valorTotal||imoveis[0]?.valor_venda||0);
    const sinal = Number(imoveis[0]?.valor_sinal||0);
    const aPagar = vv - sinal;
    const nomeAgencia = agencia==="white"?"RE/MAX White":"RE/MAX White II";
    const tituloPDF = angariacaoTipo==="externa" ? "Pedido de Informação CPCV" : "Contrato Promessa de Compra e Venda";
    const agExtNome = angariacaoTipo==="externa" && agExtAngariadora.nome ? "<p style='color:#8b5cf6;font-size:9pt'>Agência Externa: " + agExtAngariadora.nome + (agExtAngariadora.agente?" · "+agExtAngariadora.agente:"") + "</p>" : "";
    function blocoParticipante(p, label, i) {
      if (p.tipo==="empresa") return "<div class='subsecao'><div class='subsecao-titulo'>"+label+" "+(i+1)+" — "+p.nome_empresa+"</div><div class='grid3'><div class='campo'><label>NIPC</label><div class='valor'>"+(p.nipc||"—")+"</div></div><div class='campo'><label>Morada Sede</label><div class='valor'>"+(p.morada_sede||"—")+"</div></div><div class='campo'><label>Código Postal</label><div class='valor'>"+(p.codigo_postal_sede||"—")+"</div></div></div></div>";
      if (p.tipo==="heranca") return "<div class='subsecao'><div class='subsecao-titulo'>"+label+" "+(i+1)+" — Herança: "+p.nome_heranca+"</div></div>";
      return "<div class='subsecao'><div class='subsecao-titulo'>"+label+" "+(i+1)+" — "+(p.nome||"—")+"</div>" +
        "<div class='grid3'><div class='campo'><label>Nome Completo</label><div class='valor'>"+(p.nome||"—")+"</div></div><div class='campo'><label>NIF</label><div class='valor'>"+(p.nif||"—")+"</div></div><div class='campo'><label>Naturalidade</label><div class='valor'>"+(p.naturalidade||"—")+"</div></div></div>" +
        "<div class='grid3'><div class='campo'><label>CC / BI / Passaporte</label><div class='valor'>"+(p.cc||"—")+"</div></div><div class='campo'><label>Validade</label><div class='valor'>"+(p.validade_cc?new Date(p.validade_cc).toLocaleDateString("pt-PT"):"—")+"</div></div><div class='campo'><label>Estado Civil</label><div class='valor'>"+(p.estado_civil||"—")+"</div></div></div>" +
        "<div class='grid3'><div class='campo'><label>Telefone</label><div class='valor'>"+(p.telefone||"—")+"</div></div><div class='campo'><label>Email</label><div class='valor'>"+(p.email||"—")+"</div></div><div class='campo'><label>Regime Casamento</label><div class='valor'>"+(p.regime_casamento||"—")+"</div></div></div>" +
        "<div class='grid2'><div class='campo'><label>Morada</label><div class='valor'>"+(p.morada||"—")+"</div></div><div class='campo'><label>Código Postal</label><div class='valor'>"+(p.codigo_postal||"—")+"</div></div></div>" +
        (p.estado_civil==="Casado(a)" && p.conjuge?.nome ? "<div class='subsecao' style='margin-top:8px'><div class='subsecao-titulo'>Cônjuge</div><div class='grid3'><div class='campo'><label>Nome</label><div class='valor'>"+(p.conjuge.nome||"—")+"</div></div><div class='campo'><label>NIF</label><div class='valor'>"+(p.conjuge.nif||"—")+"</div></div><div class='campo'><label>CC/BI</label><div class='valor'>"+(p.conjuge.cc||"—")+"</div></div></div></div>" : "") +
        ((p.procuradores||[]).length>0 ? "<div class='subsecao' style='margin-top:8px'><div class='subsecao-titulo'>Procuradores</div>"+p.procuradores.map(pr=>"<div class='grid3'><div class='campo'><label>Nome</label><div class='valor'>"+(pr.nome||"—")+"</div></div><div class='campo'><label>NIF</label><div class='valor'>"+(pr.nif||"—")+"</div></div><div class='campo'><label>CC/BI</label><div class='valor'>"+(pr.cc||"—")+"</div></div></div>").join("")+"</div>" : "") +
        "</div>";
    }
    const secaoV = opcoes.vendedores ? "<div class='secao'><div class='secao-titulo'>Promitentes Vendedores</div>" + vendedores.map((v,i)=>blocoParticipante(v,"Vendedor",i)).join("") + "</div>" : "";
    const secaoC = opcoes.compradores ? "<div class='secao'><div class='secao-titulo'>Promitentes Compradores</div>" + compradores.map((c,i)=>blocoParticipante(c,"Comprador",i)).join("") + "</div>" : "";
    const dataLimitePDF = calcDataLimite(condicoes.data_assinatura_cpcv, prazoTipo, prazoTipo==="data"?condicoes.prazo_escritura:condicoes.prazo_dias);
    const secaoK = opcoes.condicoes ? "<div class='secao'><div class='secao-titulo'>Condições do Negócio</div>" +
      "<div class='grid3'><div class='campo'><label>Valor de Venda</label><div class='valor destaque'>"+formatEur(vv)+"</div></div><div class='campo'><label>Sinal CPCV</label><div class='valor'>"+formatEur(sinal)+"</div></div><div class='campo'><label>A Pagar na Escritura</label><div class='valor vermelho'>"+formatEur(aPagar)+"</div></div></div>" +
      "<div class='grid3'><div class='campo'><label>Forma Pagamento Sinal</label><div class='valor'>"+(condicoes.forma_pagamento_sinal||"—")+"</div></div><div class='campo'><label>IBAN</label><div class='valor'>"+(condicoes.iban_sinal||"—")+"</div></div><div class='campo'><label>Quem Marca Escritura</label><div class='valor'>"+(condicoes.quem_marca_escritura==="vendedores"?"Vendedores":condicoes.quem_marca_escritura==="compradores"?"Compradores":"—")+"</div></div></div>" +
      "<div class='grid3'><div class='campo'><label>Data Assinatura CPCV</label><div class='valor'>"+(condicoes.data_assinatura_cpcv?new Date(condicoes.data_assinatura_cpcv).toLocaleDateString("pt-PT"):"—")+"</div></div><div class='campo'><label>Prazo Escritura</label><div class='valor'>"+(condicoes.prazo_tipo==="dias"?(condicoes.prazo_dias+" dias"):condicoes.prazo_escritura?new Date(condicoes.prazo_escritura).toLocaleDateString("pt-PT"):"—")+"</div></div><div class='campo'><label>Data Limite Escritura</label><div class='valor' style='color:#2563eb;font-weight:700'>"+(dataLimitePDF?new Date(dataLimitePDF).toLocaleDateString("pt-PT"):"—")+"</div></div></div>" +
      "<div class='grid3'><div class='campo'><label>Destino do Imóvel</label><div class='valor'>"+(condicoes.habitacao==="hpp"?"Habitação Própria Permanente":condicoes.habitacao==="secundaria"?"Habitação Secundária":"—")+"</div></div><div class='campo'><label>Recurso a Crédito</label><div class='valor'>"+(condicoes.recurso_credito?"Sim":"Não")+"</div></div><div class='campo'><label>Banco</label><div class='valor'>"+(condicoes.banco_credito||"—")+"</div></div></div>" +
      (condicoes.recurso_credito?"<div class='grid2'><div class='campo'><label>Responsável Financiamento</label><div class='valor'>"+(condicoes.responsavel_financiamento||"—")+"</div></div><div class='campo'><label>Financiamento 100%</label><div class='valor'>"+(condicoes.financiamento_100pct?"Sim":"Não")+"</div></div></div>":"") +
      "<div class='grid2'><div class='campo'><label>Cláusula Aprovação Bancária</label><div class='valor'>"+(condicoes.clausula_aprovacao?"Sim":"Não")+"</div></div><div class='campo'><label>Cláusula Avaliação Bancária</label><div class='valor'>"+(condicoes.clausula_avaliacao?"Sim":"Não")+"</div></div></div>" +
      (condicoes.outras_condicoes?"<div class='campo'><label>Outras Condições</label><div class='valor'>"+condicoes.outras_condicoes+"</div></div>":"") +
      (condicoes.tem_aditamento?"<div class='subsecao' style='border-left:3px solid #7c3aed;margin-top:10px'><div class='subsecao-titulo' style='color:#7c3aed'>ADITAMENTO AO CPCV</div>"+(condicoes.adit_valor_venda?"<div class='campo'><label>Novo Valor de Venda</label><div class='valor'>"+formatEur(condicoes.adit_valor_venda)+"</div></div>":"")+(condicoes.adit_valor_sinal?"<div class='campo'><label>Novo Valor do Sinal</label><div class='valor'>"+formatEur(condicoes.adit_valor_sinal)+"</div></div>":"")+(condicoes.adit_prazo_dias?"<div class='campo'><label>Acréscimo ao Prazo</label><div class='valor'>"+condicoes.adit_prazo_dias+" dias</div></div>":"")+(condicoes.adit_clausulas?"<div class='campo'><label>Alterações</label><div class='valor'>"+condicoes.adit_clausulas+"</div></div>":"")+"</div>":"") +
      "</div>" : "";
    const secaoI = opcoes.imoveis ? "<div class='secao'><div class='secao-titulo'>Identificação do(s) Imóvel(eis)</div>" + imoveis.map((im,i)=>"<div class='subsecao'><div class='subsecao-titulo'>Imóvel "+(i+1)+(imoveis.length>1?" — "+formatEur(im.valor_venda):"")+"</div>" +
      "<div class='grid3'><div class='campo'><label>Tipo de Imóvel</label><div class='valor'>"+(im.tipo_imovel||"—")+"</div></div><div class='campo'><label>Tipologia</label><div class='valor'>"+(im.tipologia||"—")+"</div></div><div class='campo'><label>Artigo Matricial</label><div class='valor'>"+(im.artigo_matricial||"—")+"</div></div></div>" +
      "<div class='grid2'><div class='campo'><label>Fração</label><div class='valor'>"+(im.fracao||"—")+"</div></div><div class='campo'><label>Descrição Predial</label><div class='valor'>"+(im.descricao_predial||"—")+"</div></div></div>" +
      "<div class='grid2'><div class='campo'><label>Morada</label><div class='valor'>"+(im.morada||"—")+"</div></div><div class='campo'><label>Código Postal</label><div class='valor'>"+(im.codigo_postal||"—")+"</div></div></div>" +
      "<div class='grid3'><div class='campo'><label>Concelho</label><div class='valor'>"+(im.concelho||"—")+"</div></div><div class='campo'><label>Freguesia</label><div class='valor'>"+(im.freguesia||"—")+"</div></div><div class='campo'><label>Licença Utilização</label><div class='valor'>"+(im.licenca_tipo==="isencao_1951"?"Isenção — anterior a 1951":im.licenca_tipo==="isencao_simplex"?"Isenção SIMPLEX":im.licenca_tipo==="isencao_outro"?"Isenção: "+(im.licenca_isencao_motivo||""):im.licenca_utilizacao||"—")+"</div></div></div>" +
      "<div class='grid3'><div class='campo'><label>Emitida em</label><div class='valor'>"+(im.licenca_data?new Date(im.licenca_data).toLocaleDateString("pt-PT"):"—")+"</div></div><div class='campo'><label>Pela C.M. de</label><div class='valor'>"+(im.licenca_cm||"—")+"</div></div><div class='campo'><label>Condomínio</label><div class='valor'>"+(im.condominio?"Sim"+(im.empresa_condominio?" — "+im.empresa_condominio:"")+(im.valor_condominio?" · "+formatEur(im.valor_condominio):""):"Não")+"</div></div></div>" +
      "</div>").join("") + "</div>" : "";
    const css = "*{box-sizing:border-box;margin:0;padding:0}body{font-family:'Helvetica Neue',Arial,sans-serif;font-size:10.5pt;color:#1A1D24;background:#fff}@page{size:A4 portrait;margin:15mm 12mm}@media print{body{padding:0}.page{padding:0}*{-webkit-print-color-adjust:exact;print-color-adjust:exact}}.page{width:210mm;max-width:210mm;margin:0 auto;padding:10mm}.header{display:flex;justify-content:space-between;align-items:center;background:linear-gradient(90deg,#0B1B3D 0%,#1E3566 45%,#4A6BA8 100%);color:#fff;border-radius:8px;padding:16px 20px;margin-bottom:20px}.header-left h1{font-size:16pt;font-weight:700;color:#fff;margin-bottom:3px}.header-left p{font-size:9pt;color:#D5DDEE}.badge{display:inline-block;background:#fff;color:#0B1B3D;border-radius:99px;padding:4px 14px;font-size:9.5pt;font-weight:700}.secao{margin-bottom:18px}.secao-titulo{font-size:10pt;font-weight:700;color:#0B1B3D;text-transform:uppercase;letter-spacing:.06em;border-left:4px solid #1E3566;background:#F4F7FD;padding:6px 10px;margin-bottom:10px;border-radius:0 6px 6px 0}.grid2{display:grid;grid-template-columns:1fr 1fr;gap:10px}.grid3{display:grid;grid-template-columns:1fr 1fr 1fr;gap:10px}.campo{margin-bottom:8px}.campo label{font-size:7.5pt;font-weight:700;color:#6B7385;text-transform:uppercase;letter-spacing:.04em;display:block;margin-bottom:2px}.campo .valor{font-size:10.5pt;font-weight:600;color:#1A1D24;background:#F4F7FD;border:1px solid #D5DDEE;border-radius:6px;padding:5px 9px;min-height:24px}.campo .valor.destaque{background:#E8EEFA;border-color:#9FB0D3;color:#0B1B3D;font-size:12pt;font-weight:700}.campo .valor.vermelho{background:#0B1B3D;border-color:#0B1B3D;color:#fff;font-size:12pt;font-weight:700}.subsecao{background:#fff;border-radius:8px;padding:10px 12px;margin-bottom:10px;border:1px solid #D5DDEE}.subsecao-titulo{font-size:9.5pt;font-weight:700;color:#1E3566;margin-bottom:8px;padding-bottom:4px;border-bottom:1px solid #E3E6EC}.rodape{margin-top:26px;border-top:2px solid #1E3566;padding-top:10px;font-size:8pt;color:#6B7385;text-align:center}.assinatura-bloco{display:grid;grid-template-columns:1fr 1fr;gap:30px;margin-top:40px}.assinatura-linha{border-top:1px solid #1A1D24;padding-top:4px;font-size:8pt;color:#6B7385;text-align:center}";
    const html = "<!DOCTYPE html><html lang='pt'><head><meta charset='UTF-8'><title>CPCV "+refImovel+"</title><style>"+css+"</style></head><body><div class='page'><div class='header'><div class='header-left'><h1>"+tituloPDF+"</h1><p>"+nomeAgencia+" · Agente: "+(profile?.nome||"")+" · "+new Date().toLocaleDateString("pt-PT")+"</p>"+agExtNome+"</div><div><span class='badge'>"+(refImovel||"Ref. não definida")+"</span></div></div><div class='secao'><div class='secao-titulo'>Identificação do Processo</div><div class='grid3'><div class='campo'><label>Agência</label><div class='valor'>"+nomeAgencia+"</div></div><div class='campo'><label>Tipo de Partilha</label><div class='valor'>"+(angariacaoTipo==="pleno"?"Pleno":angariacaoTipo==="interna"?"Partilha Interna":"Partilha Externa")+"</div></div><div class='campo'><label>Papel do Agente</label><div class='valor'>"+(papelAgente==="angariador"?"Angariador":papelAgente==="vendedor"?"Vendedor":"Angariador e Vendedor")+" — "+(profile?.nome||"")+"</div></div></div></div>"+secaoI+secaoV+secaoC+secaoK+"<div class='assinatura-bloco'><div><div class='assinatura-linha'>Promitente(s) Vendedor(es)</div></div><div><div class='assinatura-linha'>Promitente(s) Comprador(es)</div></div></div><div class='rodape'>Equipa Sónia Cunha · RE/MAX White · Coimbra · "+new Date().toLocaleDateString("pt-PT")+"</div></div></body></html>";
    return html;
  }

  // Imprimir / guardar PDF a partir do browser (botão "Criar PDF")
  function gerarPDF(opcoes) {
    const html = construirHtmlPdf(opcoes);
    const blob = new Blob([html], {type:"text/html"});
    const url = URL.createObjectURL(blob);
    const win = window.open(url,"_blank");
    setTimeout(()=>{ if(win) win.print(); URL.revokeObjectURL(url); }, 800);
  }

  const valorTotal = imoveis.reduce((s,im)=>s+Number(im.valor_venda||0),0);
  const setC = (k,v) => setCondicoes(p=>({ ...p, [k]:v }));

  // ============= GATING ENTRE 2 CONSULTORES DA EQUIPA =============
  // Quem é quem vem do NEGÓCIO (como na base de dados): o angariador edita tudo, também a parte do comprador;
  // o consultor do comprador só a sua parte. A líder tem acesso total, sempre.
  const [papeisNeg, setPapeisNeg] = useState(null); // { ang, venda } = ids dos consultores do negócio
  useEffect(() => {
    if (!formulario?.negocio_id) return;
    supabase.from("negocios").select("consultor_ang_id, consultor_venda_id").eq("id", formulario.negocio_id).maybeSingle()
      .then(({ data }) => { if (data) setPapeisNeg({ ang: data.consultor_ang_id, venda: data.consultor_venda_id }); });
  }, [formulario?.negocio_id]); // eslint-disable-line react-hooks/exhaustive-deps
  const isPartilhaInternaEquipa = angariacaoTipo === "interna" && partilhaColega && partilhaColega.trim().length > 0;
  const ambasCompletas = formulario?.parte_ang_completa && formulario?.parte_venda_completa;
  const souAngariador = isLider || (papeisNeg ? papeisNeg.ang === profile?.id : formulario?.partilha_colega_id !== profile?.id);
  const souCompradorPartilha = !souAngariador && (papeisNeg ? papeisNeg.venda === profile?.id : formulario?.partilha_colega_id === profile?.id);
  // depois de o angariador enviar o pedido, o consultor do comprador vê o CPCV completo só para ler
  const soLeituraComprador = souCompradorPartilha && (!!formulario?.pedido_enviado_em || formulario?.estado === "enviado");
  const meuRoleNoNegocio = !isPartilhaInternaEquipa ? "ambos" : souAngariador ? "ang" : souCompradorPartilha ? "venda" : "ang";
  const podeEditar = (secao) => {
    if (isLider) return true;
    if (!isPartilhaInternaEquipa) return true;
    if (ambasCompletas) return true;
    if (meuRoleNoNegocio === "ambos" || meuRoleNoNegocio === "ang") return true; // o angariador edita as duas partes
    if (secao === "ambos" || secao === "ref") return true;
    if (secao === "ang" /* imóvel + vendedores */) return false;
    if (secao === "venda" /* compradores */) return true;
    return true;
  };
  const bloquearSe = (secao, conteudo) => {
    if (podeEditar(secao)) return conteudo;
    const dono = labelOutroConsultor(secao);
    return (
      <div style={{ position:"relative" }}>
        <div style={{ position:"absolute", top:6, right:6, zIndex:2, background:"#1a1a2e", color:"#fff", borderRadius:6, padding:"3px 8px", fontSize:10, fontWeight:600 }} title={`Apenas ${dono} pode editar esta secção`}>🔒 {dono}</div>
        <div style={{ pointerEvents:"none", opacity:0.65, border:"1.5px dashed #cbd5e1", borderRadius:8, padding:6 }}>{conteudo}</div>
      </div>
    );
  };
  const labelOutroConsultor = (secao) => {
    if (secao === "ang") return partilhaColega || "Angariador";
    if (secao === "venda") return partilhaColega || "Consultor do comprador";
    return "Outro";
  };
  // ============= PEDIDO DO CPCV =============
  // Vindo da ficha da proposta com "Pedir CPCV": leva logo para o bloco do pedido
  useEffect(() => { if (!irParaPedido) return; const t = setTimeout(() => { const el = document.getElementById("cpcv-pedido"); if (el) el.scrollIntoView({ behavior: "smooth", block: "center" }); }, 500); return () => clearTimeout(t); }, [irParaPedido]);
  const [pdfPedido, setPdfPedido] = useState(null); // { estado: "a_gerar" | "pronto" | "erro", url, base64, paginas, tamanhoKB, erro }
  const [janelaPedido, setJanelaPedido] = useState(null); // { tipo: "interno" | "externo", forcar, faltas }
  // Ao abrir a janela do pedido, cria já o PDF completo para o ver antes de enviar; é este mesmo ficheiro que segue em anexo
  useEffect(() => {
    if (!janelaPedido) { setPdfPedido((anterior) => { if (anterior && anterior.url) URL.revokeObjectURL(anterior.url); return null; }); return; }
    let cancelado = false;
    setPdfPedido({ estado: "a_gerar" });
    (async () => {
      try {
        const r = await htmlParaPdf(construirHtmlPdf({ cabecalho:true, imoveis:true, vendedores:true, compradores:true, condicoes:true, documentos:false }), { titulo: "CPCV " + refImovel });
        if (!cancelado) setPdfPedido({ estado: "pronto", url: URL.createObjectURL(r.blob), base64: r.base64, paginas: r.paginas, tamanhoKB: r.tamanhoKB });
      } catch (e) { if (!cancelado) setPdfPedido({ estado: "erro", erro: e.message }); }
    })();
    return () => { cancelado = true; };
  }, [janelaPedido]); // eslint-disable-line react-hooks/exhaustive-deps

  // o que falta para o CPCV estar completo (ENVIAR PEDIDO só fica ativo sem faltas; "Forçar envio" mostra esta lista)
  const requisitos = () => {
    const r = [];
    const externoComprador = angariacaoTipo === "externa" && papelAgente === "vendedor";
    r.push({ id: "ref", txt: "o ID do imóvel", rot: "ID do imóvel", fase: "cabecalho", ok: !!refImovel.trim(), sel: "#cpcv-ref-imovel" });
    if (!externoComprador) r.push({ id: "vend", txt: "os dados do vendedor", rot: "Dados do vendedor", fase: "vendedores", ok: !!(vendedores[0]?.nome || vendedores[0]?.nome_empresa || vendedores[0]?.nome_heranca), sel: "#cpcv-vendedores input" });
    r.push({ id: "comp", txt: "os dados do comprador", rot: "Dados do comprador", fase: "compradores", ok: !!(compradores[0]?.nome || compradores[0]?.nome_empresa || compradores[0]?.nome_heranca), sel: "#cpcv-compradores input" });
    r.push({ id: "valor", txt: "o valor de venda", rot: "Valor de venda", fase: "condicoes", ok: !!imoveis[0]?.valor_venda, rotulo: /valor de venda/i });
    r.push({ id: "morada", txt: "a morada do imóvel", rot: "Morada do imóvel", fase: "imoveis", ok: !!imoveis[0]?.morada, rotulo: /^morada/i });
    if (isPartilhaInternaEquipa) {
      r.push({ id: "pang", txt: "a parte do angariador marcada como completa", rot: "Parte do angariador completa", fase: "revisao", ok: !!formulario?.parte_ang_completa, sel: "#cpcv-partes button" });
      r.push({ id: "pcomp", txt: "a parte do comprador marcada como completa", rot: "Parte do comprador completa", fase: "revisao", ok: !!formulario?.parte_venda_completa, sel: "#cpcv-partes button" });
    }
    return r;
  };
  const faltasPedido = () => requisitos().filter(x => !x.ok).map(x => x.txt);
  // vai à fase certa, desce até ao campo em falta e marca-o a azul durante uns segundos
  const focarCampo = (req) => {
    setFase(req.fase);
    setTimeout(() => {
      let el = null;
      if (req.sel) el = document.querySelector(req.sel);
      else if (req.rotulo) {
        const sec = document.getElementById("cpcv-" + req.fase);
        const lb = sec ? Array.from(sec.querySelectorAll("label")).find(l => req.rotulo.test(l.textContent || "")) : null;
        el = lb && lb.parentElement ? lb.parentElement.querySelector("input,select,textarea") : null;
      }
      if (!el) el = document.getElementById("cpcv-" + req.fase);
      if (!el) return;
      if (el.scrollIntoView) el.scrollIntoView({ behavior: "smooth", block: "center" });
      if (el.focus) el.focus({ preventScroll: true });
      el.classList.add("cpcv-pulsar");
      setTimeout(() => el.classList.remove("cpcv-pulsar"), 2600);
    }, 180);
  };
  const fasesOk = {
    cabecalho: !!refImovel.trim(),
    imoveis: !!(imoveis[0]?.morada && imoveis[0]?.valor_venda),
    vendedores: !!(vendedores[0]?.nome || vendedores[0]?.nome_empresa || vendedores[0]?.nome_heranca),
    compradores: !!(compradores[0]?.nome || compradores[0]?.nome_empresa || compradores[0]?.nome_heranca),
    condicoes: !!condicoes.data_assinatura_cpcv,
  };
  // texto do email (o mesmo de antes)
  const corpoPedido = () => {
          const vv = Number(condicoes.adit_valor_venda||valorTotal||imoveis[0]?.valor_venda||0);
          const sinal = Number(imoveis[0]?.valor_sinal||0);
          const aPagar = vv - sinal;
          const nomeAgencia = agencia==="white"?"RE/MAX White":"RE/MAX White II";

          const corpo = `
            <div style="font-family:Arial,sans-serif;max-width:650px;margin:0 auto;color:#1a1a2e">
              <div style="background:#c8102e;padding:20px 28px;border-radius:8px 8px 0 0">
                <h1 style="color:#fff;font-size:18px;margin:0">Pedido de CPCV</h1>
                <p style="color:#ffcccc;font-size:13px;margin:4px 0 0">${refImovel} · ${nomeAgencia} · ${new Date().toLocaleDateString("pt-PT")}</p>
              </div>
              <div style="background:#f8f7f4;padding:20px 28px;border-radius:0 0 8px 8px;border:1px solid #ece9e3">
                <table style="width:100%;border-collapse:collapse;margin-bottom:16px">
                  <tr><td style="padding:8px 0;font-size:12px;color:#6b7280;width:40%">Referência do Imóvel</td><td style="font-weight:600;font-size:13px">${refImovel}</td></tr>
                  <tr><td style="padding:8px 0;font-size:12px;color:#6b7280">Agência / Agente</td><td style="font-weight:600;font-size:13px">${nomeAgencia} · ${profile?.nome||""}</td></tr>
                  <tr><td style="padding:8px 0;font-size:12px;color:#6b7280">Morada do Imóvel</td><td style="font-weight:600;font-size:13px">${imoveis[0]?.morada||"—"}</td></tr>
                  <tr><td style="padding:8px 0;font-size:12px;color:#6b7280">Vendedor(es)</td><td style="font-weight:600;font-size:13px">${vendedores.map(v=>v.tipo==="empresa"?v.nome_empresa:v.nome).filter(Boolean).join(", ")||"—"}</td></tr>
                  <tr><td style="padding:8px 0;font-size:12px;color:#6b7280">Comprador(es)</td><td style="font-weight:600;font-size:13px">${compradores.map(c=>c.tipo==="empresa"?c.nome_empresa:c.nome).filter(Boolean).join(", ")||"—"}</td></tr>
                  <tr style="background:#fff"><td style="padding:10px 8px;font-size:12px;color:#6b7280;border-radius:4px">Valor de Venda</td><td style="font-weight:700;font-size:15px;color:#10b981;padding:10px 8px">${formatEur(vv)}</td></tr>
                  <tr><td style="padding:8px 0;font-size:12px;color:#6b7280">Sinal CPCV</td><td style="font-weight:600;font-size:13px">${formatEur(sinal)}</td></tr>
                  <tr style="background:#fff1f2"><td style="padding:10px 8px;font-size:12px;color:#c8102e;border-radius:4px">A Pagar na Escritura</td><td style="font-weight:700;font-size:15px;color:#c8102e;padding:10px 8px">${formatEur(aPagar)}</td></tr>
                  <tr><td style="padding:8px 0;font-size:12px;color:#6b7280">Data Assinatura CPCV</td><td style="font-weight:600;font-size:13px">${condicoes.data_assinatura_cpcv?new Date(condicoes.data_assinatura_cpcv).toLocaleDateString("pt-PT"):"—"}</td></tr>
                  <tr><td style="padding:8px 0;font-size:12px;color:#6b7280">Prazo Escritura</td><td style="font-weight:600;font-size:13px">${condicoes.prazo_tipo==="dias"?(condicoes.prazo_dias+" dias"):condicoes.prazo_escritura?new Date(condicoes.prazo_escritura).toLocaleDateString("pt-PT"):"—"}</td></tr>
                </table>
                ${condicoes.outras_condicoes?`<div style="background:#fff;border-radius:6px;padding:10px 14px;border:1px solid #ece9e3;margin-bottom:12px"><div style="font-size:11px;color:#9ca3af;margin-bottom:4px">OUTRAS CONDIÇÕES</div><div style="font-size:13px">${condicoes.outras_condicoes}</div></div>`:""}
                <p style="font-size:11px;color:#9ca3af;margin-top:16px">O formulário CPCV completo segue em anexo neste email. · Equipa Sónia Cunha · RE/MAX White · Coimbra</p>
              </div>
            </div>`;
    return corpo;
  };
  const enviarPedido = async ({ para, cc }) => {
    const { tipo, forcar, faltas } = janelaPedido || {};
    if (!pdfPedido || pdfPedido.estado !== "pronto") { alert("O PDF ainda não está pronto. Aguarde um instante e tente de novo."); return; }
    setSaving(true);
    try {
      await guardar(estadoAtualParaGuardar, { silencioso: true }); // grava primeiro o que está no ecrã
      const idCpcv = formulario?.id || gravadoRef.current.id;
      if (!idCpcv) { alert("Guarde o CPCV antes de enviar o pedido."); setSaving(false); return; }
      const { data: { session } } = await supabase.auth.getSession();
      // assunto do email: ID do imóvel · código do negócio (NEG-AA-NNNN), quando existir
      let codigoNeg = "";
      if (formulario?.negocio_id) { try { const { data: nc } = await supabase.from("negocios").select("codigo").eq("id", formulario.negocio_id).maybeSingle(); codigoNeg = nc?.codigo || ""; } catch (e) { /* sem código: segue só com o ID */ } }
      const avisoIncompleto = forcar ? `<div style="font-family:Arial,sans-serif;max-width:650px;margin:0 auto 10px;background:#fdf0cf;color:#9a5a05;border-radius:8px;padding:10px 14px;font-size:13px"><b>Enviado incompleto.</b> Ainda falta: ${(faltas||[]).join(", ")}.</div>` : "";
      const titulo = tipo === "externo" ? "Dados da parte compradora" : (escrituraDirecta ? "Pedido de Escritura" : "Pedido CPCV");
      const resp = await fetch("/api/email-cpcv", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Authorization": `Bearer ${session?.access_token || ""}` },
        body: JSON.stringify({ assunto: `${titulo} — ${refImovel}${codigoNeg ? " · " + codigoNeg : ""}${forcar ? " · INCOMPLETO" : ""}`, corpo: avisoIncompleto + corpoPedido(), consultorEmail: profile?.email||"", pdfBase64: pdfPedido.base64, idFormulario: refImovel, tipo, para, cc })
      });
      const resultado = await resp.json();
      if (!resp.ok) { alert("Erro ao enviar email: " + (resultado.error||"desconhecido")); setSaving(false); return; }
      const agora = new Date().toISOString();
      await supabase.from("formularios_cpcv").update({ estado: "enviado", pedido_enviado_em: agora, pedido_enviado_por: profile?.id || null, pedido_emails: { para, cc }, pedido_incompleto: !!forcar, pedido_tipo: tipo }).eq("id", idCpcv);
      // o negócio passa a "CPCV pedido" (só agora, com o pedido enviado)
      if (formulario?.negocio_id) {
        const { data: negAtual } = await supabase.from("negocios").select("estado").eq("id", formulario.negocio_id).maybeSingle();
        if (negAtual?.estado === "proposta") await supabase.from("negocios").update({ estado: "cpcv_pedido", data_cpcv_pedido: hojeISO(), updated_at: agora }).eq("id", formulario.negocio_id);
      }
      try { await supabase.from("historico_cpcv").insert({ formulario_id: formulario?.id_formulario || gravadoRef.current.idForm, acao: (forcar ? "Pedido enviado incompleto" : tipo === "externo" ? "Enviado ao angariador externo" : "Pedido enviado") + " · Para: " + para.join(", ") + (cc.length ? " · CC: " + cc.join(", ") : ""), editado_por: profile?.nome || "Desconhecido", data: new Date().toISOString(), detalhes: forcar ? "Faltava: " + (faltas||[]).join(", ") : null }); } catch (e) { /* histórico é extra */ }
      // o consultor do comprador fica a saber que o pedido seguiu (e passa a ver o CPCV completo, só para ler)
      if (criarNotificacao && papeisNeg?.venda && papeisNeg.venda !== profile?.id) {
        await criarNotificacao(papeisNeg.venda, "cpcv_pedido", `${profile?.nome || "O angariador"} enviou o pedido do CPCV ${refImovel}${codigoNeg ? " · " + codigoNeg : ""}${forcar ? " (incompleto)" : ""}`, { formulario_cpcv_id: idCpcv, negocio_id: formulario?.negocio_id || null });
      }
      setJanelaPedido(null); setSaving(false);
      alert(forcar ? "Pedido enviado (marcado como incompleto)." : tipo === "externo" ? "Enviado ao angariador externo." : "✅ Pedido do CPCV enviado.");
      if (onNegocioCriado) onNegocioCriado();
    } catch (e) { alert("Erro: " + e.message); setSaving(false); }
  };

  const marcarParteCompleta = async (parte) => {
    if (!formulario?.id) { alert("Guarda primeiro o formulário antes de marcar parte completa."); return; }
    const update = parte === "ang"
      ? { parte_ang_completa: true, data_ang_completa: new Date().toISOString() }
      : { parte_venda_completa: true, data_venda_completa: new Date().toISOString() };
    const { error } = await supabase.from("formularios_cpcv").update(update).eq("id", formulario.id);
    if (error) { alert("Erro: "+error.message); return; }
    if (criarNotificacao && partilhaColega) {
      const outro = (consultores||[]).find(c => c.nome === partilhaColega);
      if (outro?.id && outro.id !== profile?.id) {
        await criarNotificacao(outro.id, "parte_completa", `${profile?.nome} marcou a parte ${parte==="ang"?"do angariador":"do comprador"} como completa no CPCV ${refImovel}`, { formulario_cpcv_id: formulario.id, negocio_id: formulario.negocio_id||null });
      }
    }
    alert(`Parte ${parte==="ang"?"do angariador":"do comprador"} marcada como completa.`);
    onVoltar();
  };

  // Auto-popular imóvel + vendedores a partir de uma angariação existente (por ref)
  const puxarDaAngariacao = async (ref) => {
    if (!ref || ref.length < 3) return;
    const ang = (angariações||[]).find(a => a.id_angariacao?.toLowerCase() === ref.toLowerCase());
    if (!ang) {
      setAngariacaoLigada(null);
      setCamposPreAng(new Set());
      if (!isEd && ref.length >= 4) setMostrarCriarAng(true);
      return;
    }
    setMostrarCriarAng(false);
    setAngariacaoLigada(ang);
    // Set de campos preenchidos para destaque
    const preenchidos = new Set();
    // Popular IMÓVEL (1º imóvel da lista) — só sobrescreve se estiver vazio
    const im0 = imoveis[0] || {};
    const novoImovel = { ...im0 };
    const setIf = (k, val, srcKey) => {
      if (val !== undefined && val !== null && val !== "" && (!im0[k] || im0[k] === "")) {
        novoImovel[k] = val;
        preenchidos.add(srcKey);
      }
    };
    setIf("tipo_imovel", ang.tipo_imovel, "imovel.tipo_imovel");
    setIf("tipologia", ang.tipologia, "imovel.tipologia");
    setIf("morada", ang.morada, "imovel.morada");
    setIf("codigo_postal", ang.codigo_postal, "imovel.codigo_postal");
    setIf("concelho", ang.concelho, "imovel.concelho");
    setIf("freguesia", ang.freguesia, "imovel.freguesia");
    setIf("artigo_matricial", ang.artigo_matricial, "imovel.artigo_matricial");
    setIf("fracao", ang.fracao, "imovel.fracao");
    setIf("descricao_predial", ang.descricao_predial, "imovel.descricao_predial");
    setIf("licenca_utilizacao", ang.licenca_numero, "imovel.licenca_utilizacao");
    setIf("licenca_data", ang.licenca_data, "imovel.licenca_data");
    setIf("licenca_cm", ang.licenca_cm, "imovel.licenca_cm");
    if (ang.condominio !== undefined && (im0.condominio === undefined || im0.condominio === null)) {
      novoImovel.condominio = ang.condominio;
      preenchidos.add("imovel.condominio");
    }
    setIf("empresa_condominio", ang.empresa_condominio, "imovel.empresa_condominio");
    setImoveis([novoImovel, ...imoveis.slice(1)]);
    // Popular VENDEDORES — normaliza para o formato CPCV (residencia → morada + campos em falta)
    const normalizarParticular = (v) => ({
      tipo: "particular",
      nome: v?.nome || "",
      naturalidade: v?.naturalidade || "",
      cc: v?.cc || "",
      validade_cc: v?.validade_cc || "",
      nif: v?.nif || "",
      telefone: v?.telefone || "",
      email: v?.email || "",
      estado_civil: v?.estado_civil || "",
      regime_casamento: v?.regime_casamento || "",
      casou_portugal: v?.casou_portugal !== false,
      pais_casamento: v?.pais_casamento || "",
      morada: v?.morada || v?.residencia || "", // ← retrocompat: residencia (formato antigo) vira morada
      codigo_postal: v?.codigo_postal || "",
      conjuge: v?.conjuge || { nome:"", naturalidade:"", cc:"", validade_cc:"", nif:"", telefone:"", email:"" },
      autorizantes: Array.isArray(v?.autorizantes) ? v.autorizantes : [],
      procuradores: Array.isArray(v?.procuradores) ? v.procuradores : [],
    });
    const normalizarHeranca = (v) => ({
      tipo: "heranca",
      nome_heranca: v?.nome_heranca || v?.nome || "",
      herdeiros: Array.isArray(v?.herdeiros) && v.herdeiros.length > 0
        ? v.herdeiros.map(h => normalizarParticular(h))
        : [normalizarParticular({})],
      autorizantes: Array.isArray(v?.autorizantes) ? v.autorizantes : [],
      procuradores: Array.isArray(v?.procuradores) ? v.procuradores : [],
    });
    const normalizarEmpresa = (v) => ({
      tipo: "empresa",
      nome_empresa: v?.nome_empresa || v?.nome || "",
      nipc: v?.nipc || v?.nif || "",
      morada_sede: v?.morada_sede || v?.morada || v?.residencia || "",
      codigo_postal_sede: v?.codigo_postal_sede || v?.codigo_postal || "",
      tem_cae_imoveis: v?.tem_cae_imoveis ?? null,
      ata_ou_socios: v?.ata_ou_socios || "ata",
      gerentes: Array.isArray(v?.gerentes) && v.gerentes.length > 0
        ? v.gerentes
        : [{ nome:"", naturalidade:"", cc:"", validade_cc:"", nif:"", telefone:"", email:"", estado_civil:"", residencia:"" }],
      procuradores: Array.isArray(v?.procuradores) ? v.procuradores : [],
    });
    const normalizarVendedor = (v) => {
      if (!v) return normalizarParticular({});
      // Detecta o tipo: explícito > inferido
      if (v.tipo === "empresa" || v.nome_empresa || v.nipc) return normalizarEmpresa(v);
      if (v.tipo === "heranca" || v.nome_heranca || Array.isArray(v.herdeiros)) return normalizarHeranca(v);
      return normalizarParticular(v); // default = particular
    };
    const vendsAng = (Array.isArray(ang.vendedores) ? ang.vendedores : []).map(normalizarVendedor);
    if (vendsAng.length > 0) {
      const temVendedoresPreenchidos = vendedores.some(v => v.nome || v.nome_empresa || v.nome_heranca);
      let aplicar = true;
      if (temVendedoresPreenchidos) {
        aplicar = window.confirm(`A angariação ${ang.id_angariacao} tem ${vendsAng.length} vendedor(es) registado(s).\n\nQueres substituir os vendedores actuais pelos dados da angariação?\n\n(Cancelar = manter o que está)`);
      }
      if (aplicar) {
        setVendedores(vendsAng);
        // Marca campos pré-preenchidos para destaque visual
        vendsAng.forEach((_, idx) => {
          ["nome","nif","cc","validade_cc","telefone","email","estado_civil","morada","codigo_postal","naturalidade","regime_casamento","nome_empresa","nipc","morada_sede","nome_heranca"].forEach(k => preenchidos.add(`vendedor.${idx}.${k}`));
        });
      }
    }
    // Lead vendedor
    if (ang.lead_vendedor_id && !leadIdVendedor) {
      setLeadIdVendedor(String(ang.lead_vendedor_id));
      preenchidos.add("lead_vendedor_id");
    }
    setCamposPreAng(preenchidos);
  };

  // ============= CASCATA: PROPOSTA + NEGÓCIO + COMISSÃO =============
  // Tabela de honorários simplificada (sem distinção exclusividade)
  const calcHonorarios = (valor) => {
    const v = Number(valor||0);
    if (!v) return 0;
    if (v <= 20000)  return v * 0.20;   // 20%
    if (v <= 50000)  return 4000;        // 4.000€ fixo
    if (v <= 100000) return 5000;        // 5.000€ fixo
    return v * 0.05;                     // 5% (até 1M e acima)
  };

  // Cria lead se vendedor/comprador não existir; retorna { lead_id, criada }
  async function ensureLead(participante, tipoCliente, idLeadOriginal) {
    // Se ja tem lead linkada, sincronizar dados do CPCV se houver campos novos
    if (idLeadOriginal && participante) {
      const lead = leads.find(l => String(l.id) === String(idLeadOriginal));
      if (lead) {
        const updates = {};
        if (participante.nome && participante.nome.length > (lead.nome_completo||"").length && participante.nome !== lead.nome) updates.nome_completo = participante.nome;
        if (participante.nif && !lead.nif) updates.nif = participante.nif;
        if (participante.cc && !lead.cc) updates.cc = participante.cc;
        if (participante.validade_cc && !lead.validade_cc) updates.validade_cc = participante.validade_cc;
        if (participante.estado_civil && !lead.estado_civil) updates.estado_civil = participante.estado_civil;
        if (participante.regime_casamento && !lead.regime_casamento) updates.regime_casamento = participante.regime_casamento;
        if (participante.naturalidade && !lead.naturalidade) updates.naturalidade = participante.naturalidade;
        if (participante.morada && !lead.morada) updates.morada = participante.morada;
        if (participante.codigo_postal && !lead.codigo_postal) updates.codigo_postal = participante.codigo_postal;
        if (participante.email && !lead.email) updates.email = participante.email;
        if (participante.telefone && !lead.telefone) updates.telefone = participante.telefone;
        if (Object.keys(updates).length > 0) await supabase.from("leads").update(updates).eq("id", idLeadOriginal);
      }
      return { lead_id: Number(idLeadOriginal), criada: false };
    }
    if (!participante || !participante.nome || !participante.nome.trim()) return { lead_id: null, criada: false };
    // Tentar match por NIF ou telefone
    const nifClean = (participante.nif||"").replace(/\D/g,"");
    const telClean = (participante.telefone||"").replace(/\D/g,"");
    let leadExistente = null;
    if (nifClean) leadExistente = leads.find(l => (l.nif||"").replace(/\D/g,"") === nifClean);
    if (!leadExistente && telClean) leadExistente = leads.find(l => (l.telefone||"").replace(/\D/g,"") === telClean);
    if (leadExistente) {
      // Sincroniza dados em falta
      const updates = {};
      if (participante.nome && !leadExistente.nome_completo) updates.nome_completo = participante.nome;
      if (participante.nif && !leadExistente.nif) updates.nif = participante.nif;
      if (participante.cc && !leadExistente.cc) updates.cc = participante.cc;
      if (Object.keys(updates).length > 0) await supabase.from("leads").update(updates).eq("id", leadExistente.id);
      return { lead_id: leadExistente.id, criada: false };
    }
    // Criar nova lead com TODOS os dados disponíveis do CPCV
    const { data:novaLead, error } = await supabase.from("leads").insert({
      nome: participante.nome,
      nome_completo: participante.nome,
      nif: participante.nif||null,
      cc: participante.cc||null,
      validade_cc: participante.validade_cc||null,
      estado_civil: participante.estado_civil||null,
      regime_casamento: participante.regime_casamento||null,
      naturalidade: participante.naturalidade||null,
      telefone: participante.telefone||"",
      email: participante.email||"",
      morada: participante.morada||"",
      codigo_postal: participante.codigo_postal||null,
      tipo_cliente: [tipoCliente],
      estado: "proposta",
      consultor_id: consId||null,
      consultor_nome: consNome||"",
      fonte: "CPCV automático",
      data_criacao: hojeISO(),
      created_by: profile?.id||null,
    }).select().single();
    if (error) { console.warn("ensureLead erro:", error); return { lead_id: null, criada: false }; }
    return { lead_id: novaLead.id, criada: true, nome: novaLead.nome, tipo: tipoCliente };
  }

  async function criarOuLigarProcesso(formularioId) {
    if (!refImovel.trim()) return;
    const refTrim = refImovel.trim();
    // ── Procurar negócio existente por VÁRIOS identificadores (evita duplicados) ──
    let matches = [];
    const pushUnique = (rows) => { if (!rows) return; for (const n of rows) if (!matches.find(m => m.id === n.id)) matches.push(n); };
    try { const { data } = await supabase.from("negocios").select("*").eq("imovel_ref", refTrim); pushUnique(data); } catch(_) {}
    if (formularioId) { try { const { data } = await supabase.from("negocios").select("*").eq("cpcv_id", formularioId); pushUnique(data); } catch(_) {} }
    if (formulario?.negocio_id) { try { const { data } = await supabase.from("negocios").select("*").eq("id", formulario.negocio_id); pushUnique(data); } catch(_) {} }
    let usarExistente = false;
    let negPreExistente = null;
    if (matches.length > 0) {
      // Preferir negócio activo (não cancelado/perdido)
      const activo = matches.find(n => !["cancelado","perdido"].includes(n.estado));
      if (activo) {
        // Existe negócio activo: ligar automaticamente, sem perguntar (nunca duplicar)
        usarExistente = true;
        negPreExistente = activo;
      } else {
        // Só há negócios cancelados/perdidos: perguntar se cria novo ou liga ao antigo
        const n = matches[0];
        const msg = `⚠️ Ref "${refTrim}" tem negócio anterior CANCELADO (${n.estado}, ${new Date(n.created_at).toLocaleDateString("pt-PT")}).\n\n[OK] = Criar novo processo\n[Cancelar] = Ligar ao existente`;
        const querCriar = window.confirm(msg);
        usarExistente = !querCriar;
        negPreExistente = querCriar ? null : n;
      }
    }
    // Se usar existente: linkar formulário ao negócio + backlink + sair
    if (usarExistente && negPreExistente) {
      await supabase.from("formularios_cpcv").update({ negocio_id: negPreExistente.id, proposta_id: negPreExistente.proposta_id||null }).eq("id", formularioId);
      if (!negPreExistente.cpcv_id) {
        try { await supabase.from("negocios").update({ cpcv_id: formularioId }).eq("id", negPreExistente.id); } catch(_) {}
      }
      if (onNegocioCriado) onNegocioCriado();
      return;
    }
    // ── Partilha externa: distinguir lado da equipa vs lado da agência externa ──
    const isExterna = angariacaoTipo === "externa";
    const equipaEAng = !isExterna || papelAgente === "angariador" || papelAgente === "ambos";
    const equipaEVenda = !isExterna || papelAgente === "vendedor" || papelAgente === "ambos";
    const angExternoBool = isExterna && !equipaEAng;      // lado angariador (vendedor) é externo
    const vendaExternoBool = isExterna && !equipaEVenda;  // lado venda (comprador) é externo
    const agExtNomeBD = isExterna ? (agExtAngariadora?.nome || agExtPartilha?.nome || null) : null;
    // Auto-criar leads — apenas para o lado INTERNO (lado externo não exige cliente)
    const avisos = [];
    let vRes = { lead_id: null, criada: false };
    let cRes = { lead_id: null, criada: false };
    if (!angExternoBool) {
      vRes = await ensureLead(vendedores[0], "Vendedor", leadIdVendedor);
      if (vRes.criada) avisos.push(`Lead Vendedor: ${vRes.nome}`);
    }
    if (!vendaExternoBool) {
      cRes = await ensureLead(compradores[0], "Comprador", leadIdComprador);
      if (cRes.criada) avisos.push(`Lead Comprador: ${cRes.nome}`);
    }
    // Consultores e valor
    const consAng = (consultores||[]).find(c => c.nome === consNome) || consultorEscolhido;
    const consVenda = partilhaColega ? (consultores||[]).find(c => c.nome === partilhaColega) : null;
    const valor = Number(imoveis[0]?.valor_venda||valorTotal||0);
    const tipoPartilha = angariacaoTipo === "interna" ? (partilhaColega ? "interna" : "pleno") : "outra_marca";
    const imovelOrigem = angariacaoTipo === "externa" ? "outra_marca" : "equipa";
    // Para proposta/negócio: se o lado é EXTERNO, o "consultor" desse lado é a agência externa (nome)
    const propConsAngId = angExternoBool ? null : (consId||null);
    const propConsAngNome = angExternoBool ? (agExtNomeBD||"Agência externa") : (consNome||"");
    const propConsAngTipo = angExternoBool ? "outra_marca" : "interno";
    const propConsVendaId = vendaExternoBool ? null : (consVenda?.id || (equipaEVenda && !partilhaColega ? consId : null));
    const propConsVendaNome = vendaExternoBool ? (agExtNomeBD||"Agência externa") : (partilhaColega || (equipaEVenda ? consNome : ""));
    const propConsVendaTipo = vendaExternoBool ? "outra_marca" : (partilhaColega ? "interno" : (equipaEVenda ? "interno" : null));
    const { data: novaProp, error: errProp } = await supabase.from("propostas").insert({
      tipo: "venda", tipo_partilha: tipoPartilha,
      data: hojeISO(),
      estado: escrituraDirecta ? "aceite" : "aceite",
      consultor_ang_nome: propConsAngNome, consultor_ang_id: propConsAngId,
      consultor_ang_tipo: propConsAngTipo,
      consultor_venda_nome: propConsVendaNome, consultor_venda_id: propConsVendaId,
      consultor_venda_tipo: propConsVendaTipo,
      reporting_split: tipoPartilha === "pleno" ? 100 : 50,
      lead_comprador_id: cRes.lead_id||null, lead_vendedor_id: vRes.lead_id||null,
      imovel_origem: imovelOrigem, imovel_ref: refImovel.trim(),
      imovel_ext_agencia: angariacaoTipo === "externa" ? agExtAngariadora?.nome||null : null,
      imovel_tipo: imoveis[0]?.tipo_imovel||null, imovel_tipologia: imoveis[0]?.tipologia||null,
      imovel_morada: imoveis[0]?.morada||null, imovel_cp: imoveis[0]?.codigo_postal||null,
      imovel_freguesia: imoveis[0]?.freguesia||null, imovel_concelho: imoveis[0]?.concelho||null,
      imovel_valor_comercializacao: valor||null,
      valor_proposto: valor||null, valor: valor||null,
      criado_por: profile?.id||null,
    }).select().single();
    if (errProp) { console.warn("Erro proposta:", errProp); alert("Aviso: não foi possível criar a proposta auto: "+errProp.message); return; }
    // Calcular comissão pela tabela simplificada
    const comissaoTotal = calcHonorarios(valor);
    const reportingAng = comissaoTotal * ((tipoPartilha === "pleno" ? 100 : 50)/100);
    const reportingVenda = comissaoTotal - reportingAng;
    // Determinar estado do negócio
    let estadoNeg = "proposta";
    if (escrituraDirecta && escrituraData) estadoNeg = "escritura_agendada";
    else if (escrituraDirecta) estadoNeg = "direto_escritura";
    else if (condicoes.data_assinatura_cpcv) estadoNeg = "cpcv_assinado";
    else estadoNeg = "cpcv_pedido";
    // Criar NEGÓCIO
    const { data: novoNeg, error: errNeg } = await supabase.from("negocios").insert({
      tipo: "venda", estado: estadoNeg,
      lead_vendedor_id: vRes.lead_id||null, lead_comprador_id: cRes.lead_id||null,
      proposta_id: novaProp.id,
      imovel_morada: imoveis[0]?.morada||null, imovel_tipo: imoveis[0]?.tipo_imovel||null,
      imovel_tipologia: imoveis[0]?.tipologia||null, imovel_ref: refImovel.trim(),
      valor_venda: valor||null,
      data_proposta: hojeISO(),
      data_cpcv_pedido: !escrituraDirecta ? hojeISO() : null,
      data_cpcv_assinado: condicoes.data_assinatura_cpcv||null,
      data_escritura_agendada: escrituraData||null,
      consultor_ang_id: propConsAngId, consultor_ang_nome: propConsAngNome,
      consultor_venda_id: propConsVendaId, consultor_venda_nome: propConsVendaNome,
      reporting_split: tipoPartilha === "pleno" ? 100 : 50,
      reporting_ang: reportingAng, reporting_venda: reportingVenda,
      externo: isExterna,
      externo_agencia: agExtNomeBD,
      cpcv_id: formularioId,
      notario_escritura: notarioNome || null,
      notario_morada: notarioMorada || null,
      notario_telefone: notarioTelefone || null,
      local_escritura_realizada: escrituraLocal || null,
      entidade_tipo: entidade.tipo || null,
      entidade_id: entidade.id || null,
      criado_por: profile?.id||null,
    }).select().single();
    if (errNeg) { console.warn("Erro negócio:", errNeg); alert("Aviso: não foi possível criar o negócio auto: "+errNeg.message); return; }
    // Criar COMISSÃO — val_consultor zera no lado externo
    const pctAng = Number(consAng?.pct_comissao||50);
    const pctVenda = Number(consVenda?.pct_comissao||50);
    const valConsAng = angExternoBool ? 0 : reportingAng * (pctAng/100);
    const valConsVenda = vendaExternoBool ? 0 : reportingVenda * (pctVenda/100);
    // Metadados (para a confirmação interactiva): valor, partilha, lado interno/externo, reporting/comissão internos
    const ladoInternoDesc = isExterna
      ? (angExternoBool ? `Vendedor — ${consNome||"interno"}` : `Angariador — ${consNome||"interno"}`)
      : (partilhaColega ? `Angariador ${consNome} ↔ Vendedor ${partilhaColega}` : `Pleno — ${consNome}`);
    const ladoExternoDesc = isExterna ? (agExtNomeBD || "Agência externa") : "—";
    const reportingInterno = isExterna
      ? (angExternoBool ? reportingVenda : reportingAng)
      : (reportingAng + reportingVenda);
    const comissaoInterna = isExterna
      ? (angExternoBool ? valConsVenda : valConsAng)
      : (valConsAng + (partilhaColega ? 0 : valConsVenda));
    const sugeridos = {
      comissao_total: comissaoTotal,
      pct_ang: pctAng, pct_venda: pctVenda,
      reporting_ang: reportingAng, reporting_venda: reportingVenda,
      val_consultor_ang: valConsAng,
      val_consultor_venda: valConsVenda,
      // Metadados para a UI da confirmação (lidos por App.js se suportados; ignorados caso contrário)
      meta_valor_negocio: valor,
      meta_tipo_partilha: tipoPartilha,
      meta_lado_interno: ladoInternoDesc,
      meta_lado_externo: ladoExternoDesc,
      meta_reporting_interno: reportingInterno,
      meta_comissao_interna: comissaoInterna,
    };
    // Pedir confirmação ao utilizador antes de gravar (callback do App.js)
    let conf = { confirmou: true, vals: sugeridos };
    if (typeof pedirConfirmacaoComissao === "function") {
      try { conf = await pedirConfirmacaoComissao(sugeridos, novoNeg); } catch(_) { conf = { confirmou: false, vals: null }; }
    }
    const f = conf.confirmou ? conf.vals : sugeridos;
    await supabase.from("comissoes").insert({
      negocio_id: novoNeg.id,
      comissao_total: Number(f.comissao_total)||0, exclusividade: true, modo_pagamento: "50_50",
      trancha1_valor: Number(f.comissao_total||0)*0.5, trancha2_valor: Number(f.comissao_total||0)*0.5,
      pct_ang: Number(f.pct_ang||pctAng), pct_venda: Number(f.pct_venda||pctVenda),
      reporting_ang: Number(f.reporting_ang||0), reporting_venda: Number(f.reporting_venda||0),
      val_consultor_ang: angExternoBool ? 0 : Number(f.val_consultor_ang||0),
      val_consultor_venda: vendaExternoBool ? 0 : Number(f.val_consultor_venda||0),
      consultor_ang_externo: angExternoBool,
      consultor_venda_externo: vendaExternoBool,
      agencia_externa_nome: agExtNomeBD,
      estado_pagamento: conf.confirmou ? (f.estado_pagamento || "activa") : "por_confirmar",
      notas: conf.confirmou ? (f.notas||null) : "⏳ Comissão por confirmar — utilizador cancelou validação no momento da criação do CPCV.",
    });
    // Linkar formulário ao negócio + proposta
    await supabase.from("formularios_cpcv").update({ negocio_id: novoNeg.id, proposta_id: novaProp.id }).eq("id", formularioId);
    if (avisos.length>0) alert("✅ Processo criado!\n\nLeads criadas automaticamente:\n• "+avisos.join("\n• ")+"\n\nVerifica os dados na vista Leads.");
    if (onNegocioCriado) onNegocioCriado();
  }

  // Impede gravações em dobro (duplo clique): o botão só fica desativado depois das verificações
  // assíncronas, e foi assim que nasceu um CPCV+negócio duplicado a 20/05/2026
  const aGuardarRef = useRef(false);
  const [ultimaGravacao, setUltimaGravacao] = useState(null);
  // GUARDAR e o guardar sozinho mantêm o estado em que o CPCV está (nunca o voltam a pôr em rascunho)
  const estadoAtualParaGuardar = formulario?.estado && formulario.estado !== "cancelado" ? formulario.estado : "rascunho";
  // Guarda sozinho 4 s depois da última alteração, quando o CPCV já foi gravado uma vez
  const primeiraVezRef = useRef(true);
  const assinaturaDados = JSON.stringify([imoveis, vendedores, compradores, condicoes, checklist, prazoTipo, leadIdVendedor, leadIdComprador, docsNegocio, refImovel]);
  useEffect(() => {
    if (primeiraVezRef.current) { primeiraVezRef.current = false; return; }
    if (!gravadoRef.current.id || soLeituraComprador || formulario?.estado === "cancelado") return;
    const t = setTimeout(() => { guardar(estadoAtualParaGuardar, { silencioso: true }); }, 4000);
    return () => clearTimeout(t);
  }, [assinaturaDados]); // eslint-disable-line react-hooks/exhaustive-deps
  // CPCV novo: depois do 1.º GUARDAR fica a saber o registo gravado, para os seguintes atualizarem em vez de criarem outro
  const gravadoRef = useRef({ id: formulario?.id || null, idForm: formulario?.id_formulario || null });
  async function guardar(estado, opcoes = {}) {
    if (aGuardarRef.current) return;
    aGuardarRef.current = true;
    try { return await guardarInterno(estado, opcoes); } finally { aGuardarRef.current = false; }
  }
  async function guardarInterno(estado, { silencioso = false } = {}) {
    if (!refImovel.trim()) {
      if (!silencioso) { setErros({ ref: "Preenche o ID / Referência do Imóvel antes de guardar." }); irPara("cpcv-cabecalho"); setTimeout(() => document.getElementById("cpcv-ref-imovel")?.focus(), 450); }
      return;
    }
    // Direto p/ Escritura → exige motivo + data prevista
    if (escrituraDirecta && estado !== "rascunho" && !silencioso) {
      if (!escDiretaMotivo) { setErros({ motivo: "Seleciona o motivo do Direto p/ Escritura." }); irPara("cpcv-direto"); return; }
      if (escDiretaMotivo === "Outro" && !escDiretaMotivoOutro.trim()) { setErros({ motivo: "Descreve o motivo \"Outro\"." }); irPara("cpcv-direto"); return; }
      if (!escrituraData) { setErros({ data: "Indica a data prevista da escritura." }); irPara("cpcv-direto"); return; }
    }
    // Prevenir CPCV duplicado: bloqueia se já existe um CPCV activo com a mesma ref_imovel
    if (!isEd && !gravadoRef.current.id) {
      const { data: cpcvsExistentes } = await supabase
        .from("formularios_cpcv")
        .select("id, id_formulario, estado")
        .eq("ref_imovel", refImovel.trim())
        .is("deleted_at", null)
        .neq("estado", "cancelado");
      if (cpcvsExistentes && cpcvsExistentes.length > 0) {
        const ex = cpcvsExistentes[0];
        alert(`⚠️ Já existe um CPCV activo para o imóvel "${refImovel}":\n\n${ex.id_formulario} · estado: ${ex.estado}\n\nNão é permitido criar duplicados. Edita o CPCV existente.`);
        return;
      }
    }
    setSaving(true);
    const lead = leads.find(l=>l.id===Number(leadId));
    const idForm = formulario?.id_formulario || gravadoRef.current.idForm || gerarId(refImovel||lead?.negocio_id_imovel||lead?.id||null, profile?.nome);
    const token = formulario?.token_externo || (estado==="aguarda_externo" ? gerarToken() : null);
    const expires = token ? new Date(Date.now()+7*24*60*60*1000).toISOString() : null;
    const limparDatas = (obj) => { const r={...obj}; Object.keys(r).forEach(k=>{ if(r[k]==="") r[k]=null; }); return r; };
    const imoveisLimpos = imoveis.map(im=>limparDatas(im));
    const condicoesLimpas = limparDatas(condicoes);
    // Lado externo: gravar "Cliente Externo" como placeholder no participante do lado externo
    const isExternaG = angariacaoTipo === "externa";
    const equipaEAngG = !isExternaG || papelAgente === "angariador" || papelAgente === "ambos";
    const equipaEVendaG = !isExternaG || papelAgente === "vendedor" || papelAgente === "ambos";
    const ladoVendedorExternoG = isExternaG && !equipaEAngG;
    const ladoCompradorExternoG = isExternaG && !equipaEVendaG;
    const semIdentidade = (p) => !p || (!p.nome && !p.nome_empresa && !p.nome_heranca);
    const vendedoresParaGravar = (vendedores||[]).map((v,i) => (ladoVendedorExternoG && i===0 && semIdentidade(v)) ? { ...(v||partVazio()), nome: "Cliente Externo" } : v);
    const compradoresParaGravar = (compradores||[]).map((c,i) => (ladoCompradorExternoG && i===0 && semIdentidade(c)) ? { ...(c||partVazio()), nome: "Cliente Externo" } : c);
    const dados = {
      id_formulario: idForm, lead_id: leadIdVendedor ? Number(leadIdVendedor) : (leadIdComprador ? Number(leadIdComprador) : null), lead_id_vendedor: leadIdVendedor ? Number(leadIdVendedor) : null, lead_id_comprador: leadIdComprador ? Number(leadIdComprador) : null,
      agencia, agente_nome: consNome||"", agente_id: consId||null,
      angariacao_tipo: angariacaoTipo === "pleno" ? "interna" : angariacaoTipo, estado, token_externo: token, token_expires_at: expires,
      ref_imovel: refImovel, papel_agente: papelAgente,
      partilha_colega: (angariacaoTipo==="interna" && partilhaColega) ? partilhaColega : null,
      partilha_colega_id: (angariacaoTipo==="interna" && partilhaColega) ? ((consultores||[]).find(c=>c.nome===partilhaColega)?.id || null) : null,
      agencia_externa_partilha: angariacaoTipo==="externa" ? agExtPartilha : null,
      tipo_imovel_checklist: tipoImovelChecklist, tipo_titular: tipoTitular,
      imoveis: imoveisLimpos, valor_total_negocio: valorTotal,
      agencia_externa: angariacaoTipo==="externa" ? agExtAngariadora : {},
      vendedores_promitentes: vendedoresParaGravar, proponentes: compradoresParaGravar,
      checklist_documentos: checklist, prazo_tipo: prazoTipo,
      ...condicoesLimpas,
      docs_negocio: docsNegocio,
      documento_assinado_path: docsNegocio.find(d=>d.id==="cpcv")?.path || null,
      documento_escritura_path: docsNegocio.find(d=>d.id==="escritura")?.path || null,
      criado_por: profile?.id || null,
      data_assinatura_cpcv: condicoesLimpas.data_assinatura_cpcv || null,
      escritura_directa: escrituraDirecta,
      escritura_directa_motivo: escrituraDirecta ? (escDiretaMotivo||null) : null,
      escritura_directa_motivo_outro: (escrituraDirecta && escDiretaMotivo==="Outro") ? (escDiretaMotivoOutro||null) : null,
      escritura_data: escrituraData || null,
      escritura_hora: escrituraHora || null,
      escritura_local: escrituraLocal || null,
      escritura_notas: escrituraNotas || null,
      notario_nome: notarioNome || null,
      entidade_tipo: entidade.tipo || null,
      entidade_id: entidade.id || null,
      notario_morada: notarioMorada || null,
      notario_telefone: notarioTelefone || null,
      negocio_id: formulario?.negocio_id || null,
      proposta_id: formulario?.proposta_id || null,
    };
    let error, savedId = formulario?.id || gravadoRef.current.id;
    if (savedId) {
      // ao atualizar, não apagar a ligação ao negócio/proposta que entretanto foi criada
      const dadosUpd = { ...dados };
      if (!dadosUpd.negocio_id) delete dadosUpd.negocio_id;
      if (!dadosUpd.proposta_id) delete dadosUpd.proposta_id;
      ({ error } = await supabase.from("formularios_cpcv").update(dadosUpd).eq("id", savedId));
    } else {
      const { id: _, ...dadosSemId } = dados;
      const { data: ins, error: errIns } = await supabase.from("formularios_cpcv").insert(dadosSemId).select().single();
      error = errIns;
      if (ins) { savedId = ins.id; gravadoRef.current = { id: ins.id, idForm }; }
    }
    setSaving(false);
    if (error) {
      console.error("Erro completo ao guardar CPCV:", error);
      if (!silencioso) alert(`Erro ao guardar:\n\n${error.message}${error.details?`\nDetalhes: ${error.details}`:""}${error.hint?`\nDica: ${error.hint}`:""}`);
      return;
    }
    try { await supabase.from("historico_cpcv").insert({ formulario_id: idForm, acao: estado === "rascunho" ? "Rascunho guardado" : estado === "aguarda_externo" ? "Link gerado para agente externo" : estado === "completo" ? "CPCV Assinado" : "Pedido enviado", editado_por: profile?.nome || "Desconhecido", data: new Date().toISOString(), detalhes: condicoes.tem_aditamento ? `Aditamento: ${condicoes.adit_clausulas||"sem notas"}` : null }); } catch(e) { console.log("historico_cpcv:", e); }
    // CASCATA: criar/ligar processo (proposta + negócio + comissão)
    // Dispara sempre que haja ref_imovel + dados mínimos, mesmo em rascunho
    // (excepto "aguarda_externo" — esse só gera link, não cria negócio).
    const semNegocio = !formulario?.negocio_id;
    const temIdentidadeVendedor = (vendedoresParaGravar||[]).some(v => v && (v.nome || v.nome_empresa || v.nome_heranca));
    const temIdentidadeComprador = (compradoresParaGravar||[]).some(c => c && (c.nome || c.nome_empresa || c.nome_heranca));
    const temDadosMinimos = !!refImovel.trim() && (
      escrituraDirecta || escrituraData || condicoesLimpas.data_assinatura_cpcv
      || (imoveis[0]?.valor_venda && Number(imoveis[0].valor_venda) > 0)
      || temIdentidadeVendedor || temIdentidadeComprador
    );
    if (!silencioso && savedId && semNegocio && estado !== "aguarda_externo" && temDadosMinimos) {
      try { await criarOuLigarProcesso(savedId); } catch(e) { console.warn("criarOuLigarProcesso:", e); alert(`Aviso: CPCV guardado, mas houve um erro ao criar negócio/proposta:\n${e.message||e}`); }
    }
    // AUTO-UPDATE estado do negócio com base no que está preenchido
    try {
      const negocioId = formulario?.negocio_id;
      if (negocioId) {
        const { data: negAtual } = await supabase.from("negocios").select("estado").eq("id", negocioId).maybeSingle();
        if (negAtual && !["vendido","arrendado","cancelado"].includes(negAtual.estado)) {
          let novoEstado = negAtual.estado;
          const updates = {};
          if (escrituraDirecta && escrituraData) { novoEstado = "escritura_agendada"; updates.data_escritura_agendada = escrituraData; }
          else if (escrituraData) { novoEstado = "escritura_agendada"; updates.data_escritura_agendada = escrituraData; }
          else if (escrituraDirecta) { novoEstado = "direto_escritura"; }
          else if (condicoesLimpas.data_assinatura_cpcv) { novoEstado = "cpcv_assinado"; updates.data_cpcv_assinado = condicoesLimpas.data_assinatura_cpcv; }
          // "CPCV pedido" só quando o angariador envia o pedido (ENVIAR PEDIDO / Forçar envio), não ao guardar
          if (novoEstado !== negAtual.estado) {
            updates.estado = novoEstado;
            updates.updated_at = new Date().toISOString();
            await supabase.from("negocios").update(updates).eq("id", negocioId);
          }
        }
      }
    } catch(e) { console.warn("auto-update negocio:", e); }
    // NOTIFICAÇÃO ao outro consultor (apenas se for partilha INTERNA entre 2 da equipa)
    try {
      if (!silencioso && criarNotificacao && angariacaoTipo === "interna" && partilhaColega && partilhaColega.trim()) {
        const outro = (consultores||[]).find(c => c.nome === partilhaColega);
        if (outro && outro.id && outro.id !== profile?.id) {
          const tipoMsg = isEd ? "editado" : "criado";
          await criarNotificacao(outro.id, "cpcv_editado", `${profile?.nome||"O angariador"} ${tipoMsg} o CPCV ${refImovel}`, { formulario_cpcv_id: savedId, negocio_id: formulario?.negocio_id||null });
        }
      }
    } catch(e) { console.warn("notificar outro:", e); }
    if (silencioso) { setUltimaGravacao(new Date()); return true; }
    if (onNegocioCriado) onNegocioCriado(); // a lista de CPCV e os negócios ficam logo atualizados, sem recarregar a página
    setUltimaGravacao(new Date());
    if (estado === "rascunho") alert("CPCV guardado.");
    else if (estado === "aguarda_externo") alert("Link gerado com sucesso!");
    else onVoltar();
  }



  return (
    <div className="cpcv-form">
      <style>{ESTILO_CPCV}</style>
      <div className="cpcv-cab">
        <div style={{ display:"flex", alignItems:"center", gap:14 }}>
          <button onClick={onVoltar} aria-label="Voltar" style={{ ...B.secundario, padding:"8px 14px", fontSize:13 }}><ArrowLeft size={16} aria-hidden="true" /> Voltar</button>
          <div style={{ flex:1, minWidth:0 }}>
            <h1 style={{ fontFamily:"inherit", fontSize:22, fontWeight:700, color:"#0B1B3D", margin:0, overflowWrap:"anywhere" }}>{isEd ? formulario.id_formulario : escrituraDirecta ? "Direto p/ Escritura" : modoEscritura==="agendamento" ? "Agendar Escritura" : "Novo CPCV"}</h1>
            <p style={{ color:"#5B6272", fontSize:12.5, margin:"2px 0 0", display:"flex", alignItems:"center", gap:8, flexWrap:"wrap" }}>
              <span>{consNome} · {new Date().toLocaleDateString("pt-PT")}</span>
              <span style={{ background:"#E7EBF3", color:"#0B1B3D", borderRadius:999, padding:"2px 12px", fontSize:12.5, fontWeight:600 }}>{isEd ? (ESTADOS_ROTULO[formulario.estado] || formulario.estado || "Rascunho") : "Novo"}</span>
            </p>
          </div>
          <div className="cpcv-cab-id" style={{ background:"#fff", border:"1px solid #E3E6EC", borderRadius:10, padding:"8px 14px", textAlign:"right", minWidth:160 }}>
            <div style={{ fontSize:12.5, color:"#5B6272", fontWeight:500 }}>ID do imóvel</div>
            <div style={{ fontSize:15, fontWeight:700, color:"#0B1B3D", fontVariantNumeric:"tabular-nums", marginTop:3 }}>{refImovel || "—"}</div>
          </div>
        </div>
        <div className="cpcv-prog">
          <span className="cpcv-prog-t">{FASES_COM_DADOS.filter(id => fasesOk[id] && !requisitos().some(x => !x.ok && x.fase === id)).length} de {FASES_COM_DADOS.length} fases completas</span>
          <div className="cpcv-prog-b"><div style={{ width: (FASES_COM_DADOS.filter(id => fasesOk[id] && !requisitos().some(x => !x.ok && x.fase === id)).length / FASES_COM_DADOS.length * 100) + "%" }} /></div>
        </div>
        <nav className="cpcv-indice" aria-label="Blocos do formulário">
          {FASES.map((f, i) => {
            const falt = requisitos().filter(x => !x.ok && x.fase === f.id).length;
            const ok = !!fasesOk[f.id] && falt === 0;
            const ativo = fase === f.id;
            return (
              <Fragment key={f.id}>
                {i > 0 && <span className="cpcv-liga" aria-hidden="true" />}
                <button type="button" aria-label={f.label} onClick={()=>irPara(f.sec)} aria-current={ativo ? "step" : undefined} className={"cpcv-passo" + (ativo ? " ativo" : "") + (ok ? " ok" : "")}>
                  <span className="cpcv-bola">{ok ? <Check size={14} aria-hidden="true" /> : i + 1}</span>
                  <span className="cpcv-passo-t">{f.label}{falt > 0 && <small>{falt} em falta</small>}</span>
                </button>
              </Fragment>
            );
          })}
          <button type="button" className="cpcv-esc" onClick={()=>irPara("cpcv-agendamento")} aria-current={fase === "escritura" ? "step" : undefined}><CalendarDays size={15} aria-hidden="true" />Marcar escritura</button>
        </nav>
      </div>

      {isLider && (
        <div style={{ background: isLiderPreenchendoOutro?paleta.avisoFundo:"#fff", border:"1px solid " + paleta.cinza200, borderRadius:10, padding:"10px 14px", marginBottom:14, display:"flex", alignItems:"center", gap:10, flexWrap:"wrap" }}>
          <span style={{ fontSize:13, fontWeight:600, color:paleta.navy900, display:"inline-flex", alignItems:"center", gap:6 }}><Crown size={15} aria-hidden="true" />Preencher em nome de</span>
          <select value={agenteEscolhidoId} onChange={e=>setAgenteEscolhidoId(e.target.value)} style={{ padding:"6px 10px", border:"1px solid " + paleta.cinza200, borderRadius:8, fontSize:13.5, background:"#fff", fontWeight:600 }}>
            <option value={profile?.id}>{profile?.nome} (eu)</option>
            {(consultores||[]).filter(c => c.id !== profile?.id).map(c => <option key={c.id} value={c.id}>{c.nome}</option>)}
          </select>
          {isLiderPreenchendoOutro && <span style={{ fontSize:12.5, color:paleta.aviso, fontWeight:600, display:"inline-flex", alignItems:"center", gap:6 }}><AlertTriangle size={14} aria-hidden="true" />O formulário ficará registado como <strong>{consNome}</strong></span>}
        </div>
      )}

      {angariacaoLigada && (
        <div style={{ background:"#fff", border:"1px solid " + paleta.cinza200, borderRadius:10, padding:"10px 14px", marginBottom:12, display:"flex", alignItems:"center", gap:10, flexWrap:"wrap" }}>
          <Link2 size={18} aria-hidden="true" style={{ color:paleta.navy700 }} />
          <div style={{ flex:1 }}>
            <div style={{ fontSize:13.5, fontWeight:600, color:paleta.navy900 }}>Ligado à angariação <strong style={{ fontVariantNumeric:"tabular-nums" }}>{angariacaoLigada.id_angariacao}</strong></div>
            <div style={{ fontSize:12.5, color:paleta.cinza600 }}>{angariacaoLigada.tipo_imovel||""} {angariacaoLigada.tipologia||""} · {angariacaoLigada.morada||""} · Preço angariação: {angariacaoLigada.preco?Number(angariacaoLigada.preco).toLocaleString("pt-PT")+" €":"—"}</div>
          </div>
          {Number(imoveis[0]?.valor_venda||0) > 0 && Number(angariacaoLigada.preco||0) > 0 && Math.abs(Number(imoveis[0].valor_venda) - Number(angariacaoLigada.preco)) > 1 && (
            <div style={{ background:paleta.avisoFundo, borderRadius:6, padding:"4px 10px", fontSize:12.5, color:paleta.aviso, fontWeight:600 }} title="O valor do negócio prevalece sobre o preço da angariação. A diferença fica registada para relatórios.">⚠️ Preço diferente (ang: {Number(angariacaoLigada.preco).toLocaleString("pt-PT")}€ vs neg: {Number(imoveis[0].valor_venda).toLocaleString("pt-PT")}€)</div>
          )}
          {onAbrirAngariacao && <button onClick={()=>onAbrirAngariacao(angariacaoLigada)} style={{ background:"#fff", color:paleta.navy900, border:"1px solid " + paleta.cinza200, borderRadius:8, padding:"5px 12px", fontSize:12.5, fontWeight:600, cursor:"pointer" }} title="Os dados do imóvel editam-se na angariação">🔒 editar na angariação</button>}
          {angHeranca && (() => { const difs = diferencas(imoveis[0], angHeranca, "cpcv"); return difs.length > 0 && (
            <div style={{ flexBasis:"100%", background:paleta.avisoFundo, borderRadius:8, padding:"8px 12px", fontSize:13, color:paleta.cinza600, display:"grid", gap:6 }}>
              <b style={{ color:paleta.aviso, display:"inline-flex", alignItems:"center", gap:6 }}><AlertTriangle size={14} aria-hidden="true" />Dados desatualizados: a angariação mudou.</b>
              <ul style={{ margin:0, paddingLeft:18 }}>{difs.map(d => <li key={d.campo}>{d.rot}: <s>{d.atual || "vazio"}</s> → <b>{d.angariacao}</b></li>)}</ul>
              <button onClick={()=>setImoveis([aplicar(imoveis[0], angHeranca, "cpcv"), ...imoveis.slice(1)])} style={{ justifySelf:"start", background:"#1E3566", color:"#fff", border:"1px solid #1E3566", borderRadius:8, padding:"6px 12px", fontSize:13, fontWeight:600, cursor:"pointer" }}>Atualizar com a angariação</button>
            </div>); })()}
        </div>
      )}
      {mostrarCriarAng && !angariacaoLigada && refImovel.length >= 4 && (
        <div style={{ background:"#fff", border:"1px solid " + paleta.cinza200, borderRadius:10, padding:"10px 14px", marginBottom:12, display:"flex", alignItems:"center", gap:10, flexWrap:"wrap" }}>
          <AlertTriangle size={18} aria-hidden="true" style={{ color:paleta.aviso }} />
          <div style={{ flex:1 }}>
            <div style={{ fontSize:13.5, fontWeight:600, color:paleta.navy900 }}>Sem angariação registada com a ref <strong style={{ fontVariantNumeric:"tabular-nums" }}>{refImovel}</strong></div>
            <div style={{ fontSize:12.5, color:paleta.cinza600 }}>Queres registar uma angariação nossa, ou este negócio é de uma angariação externa?</div>
          </div>
          <button onClick={async()=>{
            // Cria angariação rascunho com a ref e abre formulário
            const { data: novaAng, error } = await supabase.from("angariações").insert({
              id_angariacao: refImovel,
              consultor_id: profile?.id || null,
              consultor_nome: profile?.nome || "",
              tipo_negocio: "Venda",
              estado: "rascunho",
              created_by: user?.id || null,
            }).select().single();
            if (error) { alert("Erro: "+error.message); return; }
            if (fetchAngariações) await fetchAngariações();
            alert(`✅ Angariação rascunho criada com ref ${refImovel}.\n\nPodes preencher mais tarde em "Angariações".\nO CPCV continua aqui ligado a esta angariação.`);
            setAngariacaoLigada(novaAng);
            setMostrarCriarAng(false);
          }} style={{ background:"#1E3566", color:"#fff", border:"1px solid #1E3566", borderRadius:8, padding:"7px 14px", fontSize:13, fontWeight:600, cursor:"pointer" }}>Criar angariação</button>
          <button onClick={()=>{
            setAngariacaoTipo("externa");
            setMostrarCriarAng(false);
            alert("ℹ️ Modo Partilha Externa activado. Preenche os dados da agência externa na secção Identificação.");
          }} style={{ background:"#fff", color:paleta.navy900, border:"1px solid " + paleta.cinza200, borderRadius:8, padding:"7px 14px", fontSize:13, fontWeight:600, cursor:"pointer", display:"inline-flex", alignItems:"center", gap:6 }}><Building2 size={15} aria-hidden="true" />Angariação externa</button>
          <button onClick={()=>setMostrarCriarAng(false)} style={{ background:"transparent", color:paleta.cinza600, border:"none", padding:"6px 8px", fontSize:13, cursor:"pointer" }}>Ignorar</button>
        </div>
      )}
      {escrituraDirecta ? (<>
        <div style={{ background:"#fff", border:"1px solid " + paleta.cinza200, borderRadius:12, padding:"14px 18px", marginBottom:14, display:"flex", alignItems:"center", gap:12 }}>
          <AlertTriangle size={22} aria-hidden="true" style={{ color:paleta.aviso }} />
          <div style={{ flex:1 }}>
            <div style={{ fontWeight:600, color:paleta.navy900, fontSize:15 }}>Direto para escritura, sem CPCV</div>
            <div style={{ fontSize:13, color:paleta.cinza600, marginTop:2 }}>Este processo salta o CPCV e vai directamente para escritura. Preenche todos os campos do imóvel e clientes como num CPCV normal.</div>
          </div>
          <button onClick={()=>setEscrituraDirecta(false)} style={{ background:"#fff", border:"1px solid " + paleta.cinza200, color:paleta.navy900, borderRadius:8, padding:"7px 14px", fontSize:13, fontWeight:600, cursor:"pointer", whiteSpace:"nowrap" }}>
            Voltar a CPCV
          </button>
        </div>
        {/* Motivo e previsão da escritura */}
        <div id="cpcv-direto" className="cpcv-seccao" style={{ background:"#fff", border:"1px solid " + paleta.cinza200, borderRadius:12, padding:"16px 20px", marginBottom:16 }}>
          <div style={{ fontWeight:600, color:paleta.navy900, fontSize:15, marginBottom:10 }}>Motivo de "Direto p/ Escritura" *</div>
          {erros.motivo && <div role="alert" style={{ fontSize:12.5, color:"#B42318", marginBottom:8, fontWeight:600 }}>{erros.motivo}</div>}
          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:8, marginBottom:10 }}>
            {[
              "Negócio com Capitais Próprios",
              "Aguarda Aprovação Financeira",
              "Financiamento Aprovado",
              "A Rectificar Documentos",
              "Outro",
            ].map(op => (
              <label key={op} style={{ display:"flex", alignItems:"center", gap:6, fontSize:13.5, cursor:"pointer", padding:"8px 12px", background: escDiretaMotivo===op?paleta.navy50:"#fff", border:`1px solid ${escDiretaMotivo===op?paleta.navy900:paleta.cinza200}`, borderRadius:8, fontWeight:escDiretaMotivo===op?600:500 }}>
                <input type="radio" checked={escDiretaMotivo===op} onChange={()=>setEscDiretaMotivo(op)} />
                {op}
              </label>
            ))}
          </div>
          {escDiretaMotivo === "Outro" && (
            <input type="text" value={escDiretaMotivoOutro} onChange={e=>setEscDiretaMotivoOutro(e.target.value)} placeholder="Descreve o motivo..." style={{ width:"100%", padding:"9px 12px", border:"1px solid " + paleta.cinza200, borderRadius:8, fontSize:13.5, marginBottom:10, boxSizing:"border-box" }} />
          )}
          <div>
            <label style={{ fontSize:12.5, fontWeight:500, color:paleta.cinza600, display:"block", marginBottom:4 }}>Data prevista da escritura *</label>
            <input type="date" value={escrituraData} onChange={e=>{
              const v = e.target.value;
              if (v) {
                const dt = new Date(v); const hoje = new Date(); hoje.setHours(0,0,0,0);
                const max = new Date(hoje); max.setMonth(max.getMonth()+12);
                if (dt < hoje) { alert("⚠️ A data prevista não pode ser no passado."); return; }
                if (dt > max) { alert("⚠️ A data prevista não pode ser mais de 12 meses no futuro."); return; }
              }
              setEscrituraData(v);
            }} min={hojeISO()} aria-invalid={!!erros.data} style={{ padding:"8px 12px", border: erros.data ? "2px solid #B42318" : "1px solid " + paleta.cinza200, borderRadius:8, fontSize:13.5 }} />
            {erros.data && <div role="alert" style={{ fontSize:12.5, color:"#B42318", marginTop:4, fontWeight:600 }}>{erros.data}</div>}
          </div>
        </div>
      </>) : (
        <div style={{ background:"#fff", border:"1px solid " + paleta.cinza200, borderRadius:12, padding:"10px 16px", marginBottom:16, display: fase === "escritura" ? "flex" : "none", alignItems:"center", gap:10 }}>
          <span style={{ fontSize:14, color:paleta.cinza600 }}>Modo CPCV normal</span>
          <button onClick={()=>setEscrituraDirecta(true)} style={{ marginLeft:"auto", background:"#fff", border:"1px solid " + paleta.cinza200, color:paleta.navy900, borderRadius:8, padding:"7px 14px", fontSize:13, fontWeight:600, cursor:"pointer", whiteSpace:"nowrap" }}>
            Ativar direto para escritura
          </button>
        </div>
      )}

      {/* AGENDAMENTO DA ESCRITURA */}
      <div id="cpcv-agendamento" className="cpcv-seccao" style={{ ...S.secao, ...(modoEscritura==="agendamento" ? { borderColor:paleta.navy900 } : {}), ...vis("escritura") }}>
        <div style={{ ...S.barra, display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:16 }}>
          <div style={{ fontSize:16, fontWeight:600, color:"#fff", display:"flex", alignItems:"center", gap:8 }}><CalendarDays size={18} aria-hidden="true" style={{ color:"#fff" }} /> Agendamento da escritura</div>
          <button onClick={async()=>{
            // Sincronizar: tenta puxar notário do último negócio do consultor
            const { data: ultimos } = await supabase
              .from("formularios_cpcv")
              .select("notario_nome, notario_morada, notario_telefone, escritura_local")
              .or(`notario_nome.not.is.null,escritura_local.not.is.null`)
              .eq("agente_id", profile?.id)
              .is("deleted_at", null)
              .order("created_at", { ascending:false })
              .limit(5);
            if (!ultimos || !ultimos.length) { alert("Sem histórico de notário/cartório para sincronizar."); return; }
            const u = ultimos.find(x => x.notario_nome || x.escritura_local) || ultimos[0];
            const houve = [];
            if (!notarioNome && u.notario_nome) { setNotarioNome(u.notario_nome); houve.push("Notário: "+u.notario_nome); }
            if (!notarioMorada && u.notario_morada) { setNotarioMorada(u.notario_morada); houve.push("Morada"); }
            if (!notarioTelefone && u.notario_telefone) { setNotarioTelefone(u.notario_telefone); houve.push("Telefone"); }
            if (!escrituraLocal && u.escritura_local) { setEscrituraLocal(u.escritura_local); setEntidade(x => ({ ...x, id: null, nome: u.escritura_local })); houve.push("Local: "+u.escritura_local); }
            alert(houve.length ? "↻ Sincronizado:\n· "+houve.join("\n· ") : "Sem campos vazios para sincronizar.");
          }} style={{ ...B.secundario, padding:"6px 12px", fontSize:12 }} title="Puxa notário/cartório do último negócio do consultor"><RefreshCw size={14} aria-hidden="true" /> Sincronizar Dados</button>
        </div>
        <div style={S.g3}>
          <div>
            <label style={S.label}>Data Escritura</label>
            <input type="date" value={escrituraData} onChange={e=>{
              const v = e.target.value;
              if (v) {
                const dt = new Date(v); const hoje = new Date(); hoje.setHours(0,0,0,0);
                const max = new Date(hoje); max.setMonth(max.getMonth()+12);
                if (dt < hoje && !window.confirm("⚠️ A data está no passado. Continuar mesmo assim?")) return;
                if (dt > max && !window.confirm("⚠️ A data é mais de 12 meses no futuro. Continuar?")) return;
              }
              setEscrituraData(v);
            }} style={S.input} />
          </div>
          <div>
            <label style={S.label}>Hora</label>
            <input type="time" value={escrituraHora} onChange={e=>setEscrituraHora(e.target.value)} style={S.input} />
          </div>
        </div>
        <div style={{ marginBottom:12 }}>
          <EntidadeEscritura supabase={supabase} perfilId={profile?.id} valor={entidade} onChange={e => {
            setEntidade({ tipo: e.tipo || "", id: e.id || null, nome: e.nome || "" });
            setEscrituraLocal(e.nome || "");
            if (e.morada && !notarioMorada) setNotarioMorada(e.morada);
            if (e.telefone && !notarioTelefone) setNotarioTelefone(e.telefone);
          }} />
        </div>
        <div style={S.g3} >
          <div style={{ marginTop:10 }}>
            <label style={S.label}>Notário</label>
            <input type="text" value={notarioNome} onChange={e=>setNotarioNome(e.target.value)} placeholder="Nome do notário" style={S.input} />
          </div>
          <div style={{ marginTop:10 }}>
            <label style={S.label}>Morada do Cartório</label>
            <input type="text" value={notarioMorada} onChange={e=>setNotarioMorada(e.target.value)} placeholder="Morada completa" style={S.input} />
          </div>
          <div style={{ marginTop:10 }}>
            <label style={S.label}>Telefone do Cartório</label>
            <input type="tel" value={notarioTelefone} onChange={e=>setNotarioTelefone(e.target.value)} placeholder="Ex: 239 000 000" style={S.input} />
          </div>
        </div>
        <div style={{ marginTop:10 }}>
          <label style={S.label}>Notas da Escritura</label>
          <textarea value={escrituraNotas} onChange={e=>setEscrituraNotas(e.target.value)} rows={2} placeholder="Observações, documentos pendentes, contactos..." style={{ ...S.input, resize:"vertical" }} />
        </div>
      </div>

      {/* CABEÇALHO */}
      <div id="cpcv-cabecalho" className="cpcv-seccao" style={{ ...S.secao, ...vis("cabecalho") }}>
        <div style={S.titulo}><FileText size={18} aria-hidden="true" style={{ color:"#fff" }} /> Cabeçalho do formulário</div>
        <div style={S.g3}>
          <div>
            <label style={S.label}>Agência *</label>
            <select value={agencia} onChange={e=>setAgencia(e.target.value)} style={S.input}>
              {AGENCIAS.map(a=><option key={a.id} value={a.id}>{a.label}</option>)}
            </select>
          </div>
          <div>
            <label style={S.label}>Tipo de Partilha *</label>
            <select value={angariacaoTipo} onChange={e=>{ setAngariacaoTipo(e.target.value); if(e.target.value==="pleno") setPapelAgente("ambos"); }} style={S.input}>
              <option value="pleno">Pleno</option>
              <option value="interna">Partilha Interna</option>
              <option value="externa">Partilha Externa</option>
            </select>
          </div>
          <div>
            <label htmlFor="cpcv-ref-imovel" style={{ ...S.label, color: erros.ref ? "#B42318" : "#0B1B3D", fontWeight:800, letterSpacing:"0.06em" }}>ID / REFERÊNCIA DO IMÓVEL *</label>
            <input id="cpcv-ref-imovel" aria-invalid={!!erros.ref} aria-describedby="cpcv-ref-ajuda" value={refImovel} onChange={e=>{ setRefImovel(e.target.value); puxarDaAngariacao(e.target.value); }} placeholder="Ex: 12345-A" style={{ ...S.input, border: erros.ref ? "2px solid #B42318" : "2px solid #1E3566", background: erros.ref ? "#FEF3F2" : "#F4F6FA", fontWeight:700, fontFamily:"monospace" }} />
            {erros.ref && <div role="alert" style={{ fontSize:12.5, color:"#B42318", marginTop:4, fontWeight:600 }}>{erros.ref}</div>}
            <div id="cpcv-ref-ajuda" style={{ fontSize:12, color:"#5B6272", marginTop:4 }}>Chave única que liga proposta · negócio · CPCV · comissão</div>
          </div>
        </div>
        <div style={{ ...S.g2, marginTop:14 }}>
          <div>
            <label style={S.label}>Papel do agente desta equipa</label>
            <select value={papelAgente} onChange={e=>setPapelAgente(e.target.value)} style={S.input}>
              <option value="angariador">Angariador</option>
              <option value="vendedor">Vendedor</option>
              <option value="ambos">Angariador e Vendedor</option>
            </select>
          </div>
          <div>
            <label style={S.label}>Nome do Agente</label>
            <input value={profile?.nome||""} readOnly style={{...S.input, background:"#f3f4f6", color:"#6b7280"}} />
          </div>
        </div>
        <div style={{ marginTop:14 }}>
          {(angariacaoTipo==="interna" || angariacaoTipo==="pleno") && papelAgente!=="ambos" && (
            <div>
              <label style={S.label}>Colega de partilha ({papelAgente==="angariador"?"Vendedor":"Angariador"})</label>
              <select value={partilhaColega} onChange={e=>setPartilhaColega(e.target.value)} style={S.input}>
                <option value="">Selecionar colega...</option>
                {CONSULTORES.filter(c=>c!==profile?.nome).map(c=><option key={c} value={c}>{c}</option>)}
              </select>
            </div>
          )}
          {angariacaoTipo==="externa" && (
            <div style={{ ...S.sub, marginTop:10, borderLeft:"3px solid #8b5cf6" }}>
              <div style={{ fontWeight:700, fontSize:12, color:"#8b5cf6", marginBottom:12 }}>🏢 Agência Externa</div>
              <div style={{ ...S.g2, marginBottom:12 }}>
                <F label="Nome da Agência" value={agExtAngariadora.nome} onChange={v=>setAgExtAngariadora(p=>({...p,nome:v}))} />
                <F label="Nome do Agente" value={agExtAngariadora.agente} onChange={v=>setAgExtAngariadora(p=>({...p,agente:v}))} />
              </div>
              <div style={S.g2}>
                <F label="Telefone" value={agExtAngariadora.telefone} onChange={v=>setAgExtAngariadora(p=>({...p,telefone:v}))} />
                <F label="Email" value={agExtAngariadora.email} onChange={v=>setAgExtAngariadora(p=>({...p,email:v}))} type="email" />
              </div>
            </div>
          )}
        </div>
      </div>

      <div id="cpcv-imoveis" className="cpcv-seccao" style={{ ...S.secao, ...vis("imoveis") }}>
        <SecTitulo k="imoveis" icon="🏠" label={"Identificação do(s) Imóvel(eis)" + (isPartilhaInternaEquipa && !ambasCompletas ? " · 🔒 Angariador" : "")} />
        {secAberta.imoveis && bloquearSe("ang", <>
        {imoveis.map((im, i) => (
          <div key={i} style={{ ...S.sub, marginBottom:12 }}>
            <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:12 }}>
              <span style={{ fontWeight:700, fontSize:13 }}>Imóvel {i+1}</span>
              {imoveis.length>1 && <button onClick={()=>setImoveis(imoveis.filter((_,xi)=>xi!==i))} style={S.btnRem}>Remover</button>}
            </div>
            <div style={{ ...S.g3, marginBottom:12 }}>
              <F label="Tipo de Imóvel" value={im.tipo_imovel} onChange={v=>setImoveis(imoveis.map((x,xi)=>xi===i?{...x,tipo_imovel:v}:x))} opcoes={TIPOS_IMOVEL} destacar={i===0 && fromAng("imovel.tipo_imovel")} bloqueado={i===0 && bloqImovel("tipo_imovel")} />
              <F label="Artigo Matricial" value={im.artigo_matricial} onChange={v=>setImoveis(imoveis.map((x,xi)=>xi===i?{...x,artigo_matricial:v}:x))} destacar={i===0 && fromAng("imovel.artigo_matricial")} bloqueado={i===0 && bloqImovel("artigo_matricial")} />
              <F label="Fração" value={im.fracao} onChange={v=>setImoveis(imoveis.map((x,xi)=>xi===i?{...x,fracao:v}:x))} destacar={i===0 && fromAng("imovel.fracao")} bloqueado={i===0 && bloqImovel("fracao")} />
            </div>
            <div style={{ ...S.g2, marginBottom:12 }}>
              <F label="Tipologia" value={im.tipologia} onChange={v=>setImoveis(imoveis.map((x,xi)=>xi===i?{...x,tipologia:v}:x))} placeholder="Ex: T3" destacar={i===0 && fromAng("imovel.tipologia")} bloqueado={i===0 && bloqImovel("tipologia")} />
              <F label="Descrição Predial" value={im.descricao_predial} onChange={v=>setImoveis(imoveis.map((x,xi)=>xi===i?{...x,descricao_predial:v}:x))} destacar={i===0 && fromAng("imovel.descricao_predial")} bloqueado={i===0 && bloqImovel("descricao_predial")} />
            </div>
            <div style={{ marginBottom:12, padding: i===0 && (fromAng("imovel.morada")||fromAng("imovel.concelho")||fromAng("imovel.freguesia"))?"10px":"0", background: i===0 && (fromAng("imovel.morada")||fromAng("imovel.concelho")||fromAng("imovel.freguesia"))?"#eff6ff":"transparent", border: i===0 && (fromAng("imovel.morada")||fromAng("imovel.concelho")||fromAng("imovel.freguesia"))?"1.5px solid #bfdbfe":"none", borderRadius: 8, position:"relative" }}>
              {i===0 && (fromAng("imovel.morada")||fromAng("imovel.concelho")||fromAng("imovel.freguesia")) && <span title="Pré-preenchido pela angariação — editável" style={{ position:"absolute", top:8, right:8, background:"#dbeafe", color:"#1e40af", borderRadius:4, padding:"1px 6px", fontSize:9, fontWeight:700, zIndex:1 }}>📦 Da angariação</span>}
              <fieldset disabled={i===0 && bloqImovel("morada")} title={i===0 && bloqImovel("morada") ? "Vem da angariação: edita-se na angariação" : undefined} style={{ border:0, padding:0, margin:0, minWidth:0 }}>
              <SeletorLocalizacao
                value={{ distrito:im.distrito||"", concelho:im.concelho||"", freguesia:im.freguesia||"", morada:im.morada||"", codigo_postal:im.codigo_postal||"" }}
                onChange={loc => setImoveis(imoveis.map((x,xi)=>xi===i?{...x, distrito:loc.distrito||"", concelho:loc.concelho||"", freguesia:loc.freguesia||"", morada:loc.morada||"", codigo_postal:loc.codigo_postal||""}:x))}
                mostrarRapidas={false}
              />
              </fieldset>
            </div>
            <div style={{ marginBottom:12 }}>
              <label style={S.label}>Licença de Utilização</label>
              <div style={{ display:"flex", gap:12, marginBottom:8, marginTop:4, flexWrap:"wrap" }}>
                {[{v:"tem",l:"Tem LU"},{v:"isencao_1951",l:"Isenção — anterior a 1951"},{v:"isencao_simplex",l:"Isenção ao Abrigo SIMPLEX"},{v:"isencao_outro",l:"Outro motivo de isenção"}].map(({v,l})=>(
                  <label key={v} style={{ display:"flex", alignItems:"center", gap:6, fontSize:12.5, cursor:"pointer" }}>
                    <input type="radio" checked={(im.licenca_tipo||"tem")===v} onChange={()=>setImoveis(imoveis.map((x,xi)=>xi===i?{...x,licenca_tipo:v}:x))} />{l}
                  </label>
                ))}
              </div>
              {(!im.licenca_tipo || im.licenca_tipo==="tem") && (
                <div style={S.g3}>
                  <F label="N.º da Licença" value={im.licenca_utilizacao} onChange={v=>setImoveis(imoveis.map((x,xi)=>xi===i?{...x,licenca_utilizacao:v}:x))} destacar={i===0 && fromAng("imovel.licenca_utilizacao")} bloqueado={i===0 && bloqImovel("licenca_utilizacao")} />
                  <F label="Emitida em" value={im.licenca_data} onChange={v=>setImoveis(imoveis.map((x,xi)=>xi===i?{...x,licenca_data:v}:x))} type="date" destacar={i===0 && fromAng("imovel.licenca_data")} bloqueado={i===0 && bloqImovel("licenca_data")} />
                  <F label="Pela C.M. de" value={im.licenca_cm} onChange={v=>setImoveis(imoveis.map((x,xi)=>xi===i?{...x,licenca_cm:v}:x))} destacar={i===0 && fromAng("imovel.licenca_cm")} bloqueado={i===0 && bloqImovel("licenca_cm")} />
                </div>
              )}
              {im.licenca_tipo==="isencao_outro" && (
                <F label="Motivo da isenção" value={im.licenca_isencao_motivo||""} onChange={v=>setImoveis(imoveis.map((x,xi)=>xi===i?{...x,licenca_isencao_motivo:v}:x))} />
              )}
            </div>
            <div style={{ marginBottom:12 }}>
              <label style={S.label}>Condomínio?</label>
              <div style={{ display:"flex", gap:16, marginTop:6, marginBottom:8 }}>
                {[true,false].map(v=>(
                  <label key={String(v)} style={{ display:"flex", alignItems:"center", gap:6, fontSize:13, cursor:"pointer" }}>
                    <input type="radio" checked={im.condominio===v} onChange={()=>setImoveis(imoveis.map((x,xi)=>xi===i?{...x,condominio:v}:x))} />{v?"Sim":"Não"}
                  </label>
                ))}
              </div>
              {im.condominio && (
                <div style={S.g2}>
                  <F label="Empresa do Condomínio" value={im.empresa_condominio} onChange={v=>setImoveis(imoveis.map((x,xi)=>xi===i?{...x,empresa_condominio:v}:x))} />
                  <F label="Valor Mensal do Condomínio (€)" value={im.valor_condominio||""} onChange={v=>setImoveis(imoveis.map((x,xi)=>xi===i?{...x,valor_condominio:v}:x))} type="number" />
                </div>
              )}
            </div>
            {imoveis.length > 1 && (
              <div style={{ background:"#f0fdf4", borderRadius:8, padding:"10px 14px", marginBottom:10 }}>
                <F label={`Valor de Venda - Imóvel ${i+1} (€)`} value={im.valor_venda} onChange={v=>setImoveis(imoveis.map((x,xi)=>xi===i?{...x,valor_venda:v}:x))} type="number" />
              </div>
            )}
          </div>
        ))}
        <button onClick={()=>setImoveis([...imoveis,imovelVazio()])} style={S.btnAdd}>+ Adicionar Imóvel</button>
        {imoveis.length>1 && (
          <div style={{ marginTop:12, background:"#f0fdf4", borderRadius:8, padding:"10px 14px", fontSize:13.5, fontWeight:700, color:"#10b981" }}>
            Valor Total: {valorTotal.toLocaleString("pt-PT",{style:"currency",currency:"EUR"})}
          </div>
        )}
        </>)}
      </div>


      <div id="cpcv-vendedores" className="cpcv-seccao" style={{ ...S.secao, ...vis("vendedores") }}>
        <SecTitulo k="vendedores" icon="👤" label={"Promitentes Vendedores" + (isPartilhaInternaEquipa && !ambasCompletas ? " · 🔒 Angariador" : "")} />
        {secAberta.vendedores && bloquearSe("ang", <>
        <div style={{ marginBottom:14 }}>
          <label style={S.label}>{labelFromAng("Associar a Lead existente (vendedor)", "lead_vendedor_id")}</label>
          <select value={leadIdVendedor} onChange={e=>{ setLeadIdVendedor(e.target.value); aplicarLead(e.target.value, "vendedor"); }} style={styleFromAng("lead_vendedor_id", S.input)}>
            <option value="">Sem lead associada</option>
            {leads.filter(l=>(l.tipo_cliente||[]).includes("Vendedor")||!(l.tipo_cliente||[]).length).map(l=>{
              const tipos=l.tipo_cliente||[]; const letra=tipos.includes("Vendedor")?"V":tipos.includes("Comprador")?"C":tipos[0]?.[0]||"?";
              return <option key={l.id} value={String(l.id)}>{letra} · {l.nome}{l.telefone?` · ${l.telefone}`:""}</option>;
            })}
          </select>
        </div>
        {fromAng("vendedor.0.nome") && (
          <div style={{ background:"#eff6ff", border:"1.5px solid #bfdbfe", borderRadius:8, padding:"8px 12px", marginBottom:12, fontSize:11.5, color:"#1e40af", display:"flex", alignItems:"center", gap:8 }}>
            <span>📦</span>
            <span><strong>Vendedores pré-preenchidos pela angariação</strong> — os campos abaixo são editáveis (podes corrigir CC, NIF, contactos, etc.)</span>
          </div>
        )}
        <SecaoParticipantes lista={vendedores} onChange={setVendedores} tipoLabel="Vendedor" contactos={leads} />
        </>)}
      </div>


      <div id="cpcv-compradores" className="cpcv-seccao" style={{ ...S.secao, ...vis("compradores") }}>
        <SecTitulo k="compradores" icon="👥" label={"Promitentes Compradores" + (isPartilhaInternaEquipa && !ambasCompletas ? " · 🔒 Vendedor" : "")} />
        {secAberta.compradores && bloquearSe("venda", <>
        <div style={{ marginBottom:14 }}>
          <label style={S.label}>Associar a Lead existente (comprador)</label>
          <select value={leadIdComprador} onChange={e=>{ setLeadIdComprador(e.target.value); aplicarLead(e.target.value, "comprador"); }} style={S.input}>
            <option value="">Sem lead associada</option>
            {leads.filter(l=>(l.tipo_cliente||[]).includes("Comprador")||!(l.tipo_cliente||[]).length).map(l=>{
              const tipos=l.tipo_cliente||[]; const letra=tipos.includes("Comprador")?"C":tipos.includes("Vendedor")?"V":tipos[0]?.[0]||"?";
              return <option key={l.id} value={String(l.id)}>{letra} · {l.nome}{l.telefone?` · ${l.telefone}`:""}</option>;
            })}
          </select>
        </div>
        <SecaoParticipantes lista={compradores} onChange={setCompradores} tipoLabel="Comprador" contactos={leads} />
        </>)}
      </div>

      <div id="cpcv-condicoes" className="cpcv-seccao" style={{ ...S.secao, ...vis("condicoes") }}>
        <SecTitulo k="condicoes" icon="📝" label="Condições do Negócio" />
        {secAberta.condicoes && <>
        <div style={{ ...S.sub, marginTop:0, marginBottom:14 }}>
          <div style={SUBT}>Valores do negócio</div>
          {imoveis.length > 1 ? (
            <div style={{ marginBottom:12 }}>
              {imoveis.map((im,i)=>(
                <div key={i} style={{ display:"flex", alignItems:"center", gap:12, marginBottom:8 }}>
                  <span style={{ fontSize:12.5, fontWeight:600, color:"#5B6272", minWidth:80 }}>Imóvel {i+1}</span>
                  <input type="number" value={im.valor_venda} onChange={e=>setImoveis(imoveis.map((x,xi)=>xi===i?{...x,valor_venda:e.target.value}:x))} placeholder="Valor de venda (€)" style={{...S.input, flex:1}} />
                </div>
              ))}
              <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", borderTop:"1px solid #E3E6EC", paddingTop:10, marginTop:6 }}>
                <span style={{ fontWeight:700, fontSize:13, color:"#0B1B3D" }}>Total: {valorTotal.toLocaleString("pt-PT",{style:"currency",currency:"EUR"})}</span>
                {imoveis.some(im=>!im.valor_venda) && <span style={{ fontSize:12.5, color:"#B42318", display:"inline-flex", alignItems:"center", gap:5 }}><AlertTriangle size={14} aria-hidden="true" />Preenche todos os valores</span>}
              </div>
            </div>
          ) : (
            <div style={{ marginBottom:12 }}>
              <label style={S.label}>Valor de venda (€)</label>
              <input value={imoveis[0].valor_venda ? formatEur(imoveis[0].valor_venda) : ""} onChange={e=>setImoveis([{...imoveis[0],valor_venda:parseEur(e.target.value)}])} placeholder="Ex: 120.000 €" style={S.input} />
            </div>
          )}
          <div style={{ ...S.g2, marginBottom:12 }}>
            <div>
              <label style={S.label}>Valor do sinal no CPCV (€)</label>
              <input value={imoveis[0].valor_sinal ? formatEur(imoveis[0].valor_sinal) : ""} onChange={e=>setImoveis(imoveis.map((x,xi)=>xi===0?{...x,valor_sinal:parseEur(e.target.value)}:x))} placeholder="Ex: 10.000 €" style={S.input} />
            </div>
            <div>
              <label style={S.label}>Forma de pagamento do sinal</label>
              <select value={condicoes.forma_pagamento_sinal} onChange={e=>setC("forma_pagamento_sinal",e.target.value)} style={S.input}>
                <option value="">Selecionar...</option>
                <option value="cheque">Cheque</option>
                <option value="transferencia">Transferência bancária</option>
                <option value="numerario">Numerário</option>
              </select>
            </div>
          </div>
          <div style={{ background:paleta.navy100, borderRadius:8, padding:"10px 14px", marginBottom:12 }}>
            <label style={{...S.label, color:paleta.navy700}}>Valor final a pagar na escritura (€)</label>
            <div style={{ fontSize:18, fontWeight:700, color:paleta.navy900, fontVariantNumeric:"tabular-nums" }}>
              {(Number(valorTotal||imoveis[0]?.valor_venda||0) - Number(imoveis[0]?.valor_sinal||0)).toLocaleString("pt-PT",{style:"currency",currency:"EUR"})}
            </div>
            <div style={{ fontSize:12.5, color:"#5B6272", marginTop:2 }}>Valor de venda menos valor do sinal</div>
          </div>
          <div style={{ marginBottom:12 }}>
            <div style={S.g2}>
              <F label="IBAN do comprador (paga o sinal)" value={condicoes.iban_comprador} onChange={v=>setC("iban_comprador",v)} placeholder="PT50 0000 0000 0000 0000 0000 0" />
              {bloquearSe("ang", <F label="IBAN do vendedor (recebe o sinal)" value={condicoes.iban_sinal} onChange={v=>setC("iban_sinal",v)} placeholder="PT50 0000 0000 0000 0000 0000 0" />)}
            </div>
          </div>
</div>
<div style={{ ...S.sub, marginTop:0, marginBottom:14 }}>
<div style={SUBT}>Prazos da escritura</div>
          <div style={{ ...S.g2, marginBottom:12 }}>
            <F label="Data de assinatura do CPCV" value={condicoes.data_assinatura_cpcv} onChange={v=>setC("data_assinatura_cpcv",v)} type="date" />
            <div>
              <label style={S.label}>Prazo para a escritura</label>
              <div style={{ display:"flex", gap:12, marginBottom:6, marginTop:2 }}>
                {[{v:"data",l:"Data"},{v:"dias",l:"Dias"}].map(({v,l})=>(
                  <label key={v} style={{ display:"flex", alignItems:"center", gap:5, fontSize:12.5, cursor:"pointer" }}>
                    <input type="radio" checked={prazoTipo===v} onChange={()=>setPrazoTipo(v)} />{l}
                  </label>
                ))}
              </div>
              {prazoTipo==="data"
                ? <input type="date" value={condicoes.prazo_escritura} onChange={e=>setC("prazo_escritura",e.target.value)} style={S.input} />
                : <input type="number" value={condicoes.prazo_dias} onChange={e=>setC("prazo_dias",e.target.value)} placeholder="Ex: 90 dias" style={S.input} />
              }
            </div>
          </div>
          {(() => {
            const dataLimite = calcDataLimite(condicoes.data_assinatura_cpcv, prazoTipo, prazoTipo==="data"?condicoes.prazo_escritura:condicoes.prazo_dias);
            const dataLimiteAdit = condicoes.tem_aditamento && condicoes.adit_prazo_dias ? calcDataLimite(condicoes.data_assinatura_cpcv, "dias", Number(condicoes.prazo_dias||0)+Number(condicoes.adit_prazo_dias||0)) : condicoes.tem_aditamento && condicoes.adit_data_escritura ? condicoes.adit_data_escritura : null;
            const dataFinal = dataLimiteAdit || dataLimite;
            const alerta15 = dataFinal && (new Date(dataFinal)-new Date())/(1000*60*60*24) <= 15 && (new Date(dataFinal)-new Date())/(1000*60*60*24) > 0;
            return dataFinal ? (
              <div id="data-limite-escritura" style={{ background: alerta15?paleta.perigoFundo:paleta.navy100, borderRadius:8, padding:"10px 14px", marginBottom:12, border: alerta15?"1px solid #F3B8B2":"none" }}>
                <label style={{...S.label, color: alerta15?paleta.perigo:paleta.navy900}}>Data limite para a escritura {dataLimiteAdit?"(após aditamento)":""}</label>
                <div style={{ fontSize:15, fontWeight:700, color: alerta15?paleta.perigo:paleta.navy900 }}>
                  {new Date(dataFinal).toLocaleDateString("pt-PT")}
                </div>
                {alerta15 && <div style={{ fontSize:12.5, color:paleta.perigo, marginTop:4, display:"flex", alignItems:"center", gap:5 }}><AlertTriangle size={14} aria-hidden="true" />Escritura nos próximos 15 dias</div>}
              </div>
            ) : (
              <div id="data-limite-escritura" style={{ background:paleta.navy50, borderRadius:8, padding:"10px 14px", marginBottom:12, border:"1px solid " + paleta.cinza200 }}>
                <label style={{...S.label, color:paleta.cinza600}}>Data limite para a escritura</label>
                <div style={{ fontSize:13, color:paleta.cinza600 }}>Preenche a data de assinatura do CPCV e o prazo acima para calcular.</div>
              </div>
            );
          })()}
</div>
<div style={{ ...S.sub, marginTop:0, marginBottom:14 }}>
<div style={SUBT}>Aditamento</div>
          <div>
            <label style={{ ...S.label, color:"#0B1B3D", display:"flex", alignItems:"center", gap:8, cursor:"pointer", marginBottom:0 }}>
              <input type="checkbox" checked={condicoes.tem_aditamento||false} onChange={e=>setC("tem_aditamento",e.target.checked)} />
              Aditamento ao CPCV
            </label>
            {condicoes.tem_aditamento && (
              <div style={{ background:"#fff", border:"1px solid " + paleta.cinza200, borderRadius:10, padding:"14px", marginTop:10 }}>
                <div style={{ fontWeight:600, fontSize:13.5, color:"#0B1B3D", marginBottom:12 }}>Alterações por aditamento</div>
                <div style={{ ...S.g2, marginBottom:12 }}>
                  <div>
                    <label style={S.label}>Novo Valor de Venda (€)</label>
                    <input value={condicoes.adit_valor_venda ? formatEur(condicoes.adit_valor_venda) : ""} onChange={e=>setC("adit_valor_venda",parseEur(e.target.value))} placeholder="Deixa vazio se não altera" style={S.input} />
                  </div>
                  <div>
                    <label style={S.label}>Novo Valor do Sinal (€)</label>
                    <input value={condicoes.adit_valor_sinal ? formatEur(condicoes.adit_valor_sinal) : ""} onChange={e=>setC("adit_valor_sinal",parseEur(e.target.value))} placeholder="Deixa vazio se não altera" style={S.input} />
                  </div>
                </div>
                <div style={{ ...S.g2, marginBottom:12 }}>
                  <F label="Valor de Reforço do Sinal (€)" value={condicoes.adit_valor_reforco ? formatEur(condicoes.adit_valor_reforco) : ""} onChange={v=>setC("adit_valor_reforco",parseEur(v))} placeholder="Deixa vazio se não altera" />
                  <F label="Data do Reforço" value={condicoes.adit_data_reforco} onChange={v=>setC("adit_data_reforco",v)} type="date" />
                </div>
                <div style={{ ...S.g2, marginBottom:12 }}>
                  <F label="Acréscimo ao Prazo (dias)" value={condicoes.adit_prazo_dias} onChange={v=>setC("adit_prazo_dias",v)} type="number" placeholder="Ex: 30 dias adicionais" />
                  <F label="Nova Data Limite Escritura" value={condicoes.adit_data_escritura} onChange={v=>setC("adit_data_escritura",v)} type="date" />
                </div>
                <F label="Descrição das Alterações" value={condicoes.adit_clausulas} onChange={v=>setC("adit_clausulas",v)} />
                {(() => {
                  const vv = Number(condicoes.adit_valor_venda||valorTotal||imoveis[0]?.valor_venda||0);
                  const sinal = Number(condicoes.adit_valor_sinal||imoveis[0]?.valor_sinal||0);
                  const reforco = Number(condicoes.adit_valor_reforco||0);
                  const aPagar = vv - sinal - reforco;
                  const prazoBase = Number(condicoes.prazo_dias||0);
                  const prazoExtra = Number(condicoes.adit_prazo_dias||0);
                  const dataLimiteAdit = condicoes.adit_data_escritura || (condicoes.data_assinatura_cpcv && (prazoBase+prazoExtra) ? calcDataLimite(condicoes.data_assinatura_cpcv,"dias",prazoBase+prazoExtra) : null);
                  return (
                    <div style={{ background:paleta.navy100, borderRadius:8, padding:"12px 14px", marginTop:12 }}>
                      <div style={{ fontSize:13.5, fontWeight:600, color:"#0B1B3D", marginBottom:8 }}>Valores após aditamento</div>
                      <div style={{ fontSize:13, color:"#1A1D24", lineHeight:2 }}>
                        Valor de Venda: <strong>{formatEur(vv)}</strong><br/>
                        Sinal: <strong>{formatEur(sinal)}</strong>{reforco>0?<> · Reforço: <strong>{formatEur(reforco)}</strong></>:null}<br/>
                        A pagar na Escritura: <strong style={{ color:"#0B1B3D", fontSize:15 }}>{formatEur(aPagar)}</strong><br/>
                        {dataLimiteAdit && <>Data Limite Escritura: <strong style={{ color: (new Date(dataLimiteAdit)-new Date())/(1000*60*60*24)<=15?paleta.perigo:paleta.navy900 }}>{new Date(dataLimiteAdit).toLocaleDateString("pt-PT")}</strong></>}
                      </div>
                    </div>
                  );
                })()}
              </div>
            )}
          </div>
        </div>
<div style={{ ...S.sub, marginTop:0, marginBottom:14 }}>
<div style={SUBT}>Escritura</div>
        <div style={S.g2}>
          <div>
            <label style={S.label}>Quem marca a escritura?</label>
            <select value={condicoes.quem_marca_escritura} onChange={e=>setC("quem_marca_escritura",e.target.value)} style={S.input}>
              <option value="">Selecionar...</option>
              <option value="vendedores">Vendedores</option>
              <option value="compradores">Compradores</option>
            </select>
          </div>
        </div>
        <div style={{ marginTop:14 }}>
          <label style={S.label}>Destino do imóvel</label>
          <div style={{ display:"flex", gap:20, marginTop:6 }}>
            {[{v:"hpp",l:"Habitação Própria Permanente"},{v:"secundaria",l:"Habitação Secundária"}].map(({v,l})=>(
              <label key={v} style={{ display:"flex", alignItems:"center", gap:6, fontSize:13, cursor:"pointer" }}>
                <input type="radio" checked={condicoes.habitacao===v} onChange={()=>setC("habitacao",v)} />{l}
              </label>
            ))}
          </div>
        </div>
</div>
<div style={{ ...S.sub, marginTop:0, marginBottom:14 }}>
<div style={SUBT}>Financiamento</div>
          <div style={{ display:"flex", flexWrap:"wrap", gap:20, marginBottom:12 }}>
            <label style={{ display:"flex", alignItems:"center", gap:8, fontSize:13, cursor:"pointer" }}>
              <input type="checkbox" checked={condicoes.recurso_credito} onChange={e=>setC("recurso_credito",e.target.checked)} />Há recurso a crédito
            </label>
            <label style={{ display:"flex", alignItems:"center", gap:8, fontSize:13, cursor:"pointer" }}>
              <input type="checkbox" checked={condicoes.financiamento_100pct} onChange={e=>setC("financiamento_100pct",e.target.checked)} />Financiamento a 100% (garantia estado)
            </label>
            <label style={{ display:"flex", alignItems:"center", gap:8, fontSize:13, cursor:"pointer" }}>
              <input type="checkbox" checked={condicoes.clausula_aprovacao} onChange={e=>setC("clausula_aprovacao",e.target.checked)} />Cláusula de aprovação bancária
            </label>
            <label style={{ display:"flex", alignItems:"center", gap:8, fontSize:13, cursor:"pointer" }}>
              <input type="checkbox" checked={condicoes.clausula_avaliacao} onChange={e=>setC("clausula_avaliacao",e.target.checked)} />Cláusula de avaliação bancária
            </label>
          </div>
          {condicoes.recurso_credito && (
            <div style={S.g2}>
              <F label="Banco" value={condicoes.banco_credito} onChange={v=>setC("banco_credito",v)} placeholder="Nome do banco..." />
              <F label="Valor a financiar (€)" value={condicoes.valor_a_financiar ? formatEur(condicoes.valor_a_financiar) : ""} onChange={v=>setC("valor_a_financiar",parseEur(v))} placeholder="Ex: 180.000 €" />
              <F label="Responsável pelo financiamento" value={condicoes.responsavel_financiamento} onChange={v=>setC("responsavel_financiamento",v)} opcoes={RESPONSAVEL_FINANCIAMENTO_OPS} />
            </div>
          )}
        </div>
<div style={{ ...S.sub, marginTop:0 }}>
<div style={SUBT}>Outras condições e notas</div>
        <div>
          <label style={S.label}>Outras condições</label>
          <textarea value={condicoes.outras_condicoes} onChange={e=>setC("outras_condicoes",e.target.value)} rows={3} style={{ ...S.input, resize:"vertical" }} placeholder="Condições especiais acordadas entre as partes..." />
        </div>
        <div style={{ marginTop:14 }}>
          <label style={S.label}>Notas internas (não aparecem no PDF)</label>
          <textarea value={condicoes.notas_internas||""} onChange={e=>setC("notas_internas",e.target.value)} rows={3} style={{ ...S.input, resize:"vertical", background:"#fff" }} placeholder="Notas internas da equipa, observações do processo..." />
        </div>
</div>
        </>}
      </div>

      <div id="cpcv-documentos" className="cpcv-seccao" style={{ ...S.secao, ...vis("documentos") }}>
        <SecTitulo k="documentos" icon="📎" label="Documentos Necessários" />
        {secAberta.documentos && <>
        <ChecklistDocumentos
          supabase={supabase}
          formularioId={formulario?.id || "novo"}
          tipoImovelInicial={tipoImovelChecklist}
          tipoTitularInicial={tipoTitular}
          temFinanciamento={condicoes.recurso_credito}
          value={checklist}
          onChange={setChecklist}
          onTipoImovelChange={setTipoImovelChecklist}
          onTipoTitularChange={setTipoTitular}
          isLider={isLider}
        />
        </>}
      </div>

      <div id="cpcv-docsnegocio" className="cpcv-seccao" style={{ ...S.secao, ...vis("documentos") }}>
        <div style={{ ...S.barra, display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom: secAberta.docsnegocio ? 16 : -20, borderRadius: secAberta.docsnegocio ? "11px 11px 0 0" : 11 }}>
          <SecTitulo k="docsnegocio" icon="📁" label="Documentos do negócio" semBarra />
          {secAberta.docsnegocio && <button onClick={()=>setDocsNegocio(d=>[...d,{id:"doc_"+Date.now(),label:"Novo Documento",path:""}])} style={{ background:"#f0fdf4", color:"#16a34a", border:"1.5px solid #bbf7d0", borderRadius:8, padding:"6px 12px", fontSize:12, fontWeight:600, cursor:"pointer" }}>+ Adicionar</button>}
        </div>
        {secAberta.docsnegocio && docsNegocio.map((doc, idx) => (
          <div key={doc.id} style={{ background:"#f8f7f4", borderRadius:10, padding:"12px 14px", marginBottom:10, border:"1.5px solid #ece9e3" }}>
            <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom:8 }}>
              <input value={doc.label} onChange={e=>setDocsNegocio(d=>d.map((x,i)=>i===idx?{...x,label:e.target.value}:x))} style={{ ...S.input, fontWeight:600, fontSize:12, flex:1 }} />
              <button onClick={()=>{ if(window.confirm("Remover este campo?")) setDocsNegocio(d=>d.filter((_,i)=>i!==idx)); }} style={{ background:"#fef2f2", color:"#ef4444", border:"none", borderRadius:6, padding:"5px 8px", fontSize:11, cursor:"pointer" }}>🗑</button>
            </div>
            {doc.path ? (
              <div style={{ display:"flex", alignItems:"center", gap:8, flexWrap:"wrap" }}>
                <span style={{ fontSize:12, color:"#10b981", fontWeight:600 }}>✅ {doc.path.split("/").pop()}</span>
                <button onClick={async()=>{
                  const { data } = await supabase.storage.from("documentos-cpcv").createSignedUrl(doc.path, 300);
                  if (data?.signedUrl) window.open(data.signedUrl, "_blank");
                  else alert("Erro ao abrir documento.");
                }} style={{ background:"#eff6ff", color:"#2563eb", border:"1.5px solid #bfdbfe", borderRadius:7, padding:"4px 10px", fontSize:11.5, fontWeight:600, cursor:"pointer" }}>Ver / Descarregar</button>
                <button onClick={async()=>{
                  if (!window.confirm("Apagar este documento?")) return;
                  await supabase.storage.from("documentos-cpcv").remove([doc.path]);
                  setDocsNegocio(d=>d.map((x,i)=>i===idx?{...x,path:""}:x));
                }} style={{ background:"#fef2f2", color:"#ef4444", border:"1.5px solid #fecaca", borderRadius:7, padding:"4px 8px", fontSize:11.5, cursor:"pointer" }}>🗑 Apagar</button>
              </div>
            ) : (
              <button onClick={()=>{
                const inp = document.createElement("input");
                inp.type = "file"; inp.accept = ".pdf,.jpg,.jpeg,.png";
                inp.onchange = async(e)=>{
                  const file = e.target.files[0]; if (!file) return;
                  const nome = file.name.replace(/[^a-zA-Z0-9._-]/g,"_");
                  const path = `cpcv/${refImovel||"sem-ref"}/${Date.now()}_${nome}`;
                  const { error } = await supabase.storage.from("documentos-cpcv").upload(path, file);
                  if (error) { alert("Erro: "+error.message); return; }
                  setDocsNegocio(d=>d.map((x,i)=>i===idx?{...x,path}:x));
                };
                inp.click();
              }} style={{ background:"#fff", color:"#374151", border:"1.5px dashed #d1d5db", borderRadius:8, padding:"7px 14px", fontSize:12.5, fontWeight:600, cursor:"pointer", width:"100%" }}>
                📎 Carregar ficheiro
              </button>
            )}
          </div>
        ))}
      </div>

      {soLeituraComprador && (
        <div role="status" style={{ background:"#12244f", color:"#fff", borderRadius:10, padding:"10px 16px", marginBottom:14, fontSize:13, fontWeight:600 }}>
          📨 CPCV pedido · completo{formulario?.pedido_enviado_em ? ` · enviado a ${new Date(formulario.pedido_enviado_em).toLocaleDateString("pt-PT")}` : ""}. Só o angariador ou a líder o podem alterar.
        </div>
      )}
      <div id="cpcv-revisao" className="cpcv-seccao" style={{ ...S.secao, ...vis("revisao") }}>
        {(() => {
          const reqs = requisitos();
          const feitos = reqs.filter(x => x.ok).length;
          const faltas = reqs.filter(x => !x.ok);
          const pct = reqs.length ? Math.round(feitos / reqs.length * 100) : 0;
          const externo = angariacaoTipo === "externa" && papelAgente === "vendedor";
          const podeEnviar = !soLeituraComprador && (externo || souAngariador);
          const tipo = externo ? "externo" : "interno";
          const rotulo = externo ? "Enviar ao angariador externo" : escrituraDirecta ? "ENVIAR PEDIDO DE ESCRITURA" : "ENVIAR PEDIDO";
          const nomes = (lista) => lista.map(p => p.tipo === "empresa" ? p.nome_empresa : p.tipo === "heranca" ? p.nome_heranca : p.nome).filter(Boolean).join(", ") || "—";
          const resumo = [["ID do imóvel", refImovel || "—"], ["Valor de venda", imoveis[0]?.valor_venda ? formatEur(valorTotal || imoveis[0].valor_venda) : "—"], ["Morada", imoveis[0]?.morada || "—"], ["Vendedores", nomes(vendedores)], ["Compradores", nomes(compradores)]];
          return <>
            <div style={{ ...S.titulo, justifyContent:"space-between" }}>
              <span style={{ display:"inline-flex", alignItems:"center", gap:8 }}><CheckCircle2 size={18} aria-hidden="true" style={{ color:"#fff" }} /> Rever e enviar</span>
              <span style={{ fontSize:12.5, fontWeight:600, background:"rgba(255,255,255,0.18)", padding:"2px 10px", borderRadius:999, fontVariantNumeric:"tabular-nums" }}>{feitos} de {reqs.length}</span>
            </div>
            <div style={{ ...S.sub, marginTop:0, marginBottom:14 }}>
              <div style={SUBT}>Resumo do pedido</div>
              <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit, minmax(210px, 1fr))", gap:"10px 20px" }}>
                {resumo.map(([k, v]) => (
                  <div key={k} style={{ minWidth:0 }}>
                    <div style={{ fontSize:12.5, color:"#5B6272", marginBottom:3 }}>{k}</div>
                    <div style={{ fontWeight:600, fontSize:14, color:"#0B1B3D", wordBreak:"break-word", fontVariantNumeric:"tabular-nums" }}>{v}</div>
                  </div>
                ))}
              </div>
            </div>
            {isPartilhaInternaEquipa && (
              <div id="cpcv-partes" style={{ ...S.sub, marginTop:0, marginBottom:14 }}>
                <div style={SUBT}>Partilha interna: {profile?.nome} e {partilhaColega}</div>
                <div style={{ fontSize:13, color:"#5B6272", marginBottom:12 }}>O angariador preenche o imóvel e os vendedores. O consultor do comprador preenche os compradores e as condições. Quando as duas partes estiverem completas, o angariador envia o pedido.</div>
                <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit, minmax(240px, 1fr))", gap:12 }}>
                  {[["ang", "Parte do angariador", formulario?.parte_ang_completa, formulario?.data_ang_completa, (meuRoleNoNegocio === "ang" || meuRoleNoNegocio === "ambos" || isLider), "Aguarda o angariador"],
                    ["venda", "Parte do comprador", formulario?.parte_venda_completa, formulario?.data_venda_completa, (meuRoleNoNegocio === "venda" || meuRoleNoNegocio === "ambos" || isLider), "Aguarda o consultor do comprador"]].map(([k, rot, feita, data, pode, espera]) => (
                    <div key={k} style={{ background:"#fff", border:"1px solid #E3E6EC", borderRadius:10, padding:"10px 14px" }}>
                      <div style={{ fontSize:12.5, color:"#5B6272", marginBottom:6 }}>{rot}</div>
                      {feita
                        ? <div style={{ display:"inline-flex", alignItems:"center", gap:6, fontWeight:600, color:"#067647", fontSize:14 }}><CheckCircle2 size={16} aria-hidden="true" />Completa{data ? " (" + new Date(data).toLocaleDateString("pt-PT") + ")" : ""}</div>
                        : pode
                          ? <button type="button" onClick={()=>marcarParteCompleta(k)} style={{ ...B.primario, padding:"7px 14px", fontSize:13 }}><Check size={15} aria-hidden="true" />Marcar como completa</button>
                          : <div style={{ fontSize:13, color:"#5B6272" }}>{espera}</div>}
                    </div>
                  ))}
                </div>
              </div>
            )}
            <div id="cpcv-pedido" style={{ ...S.sub, marginTop:0, marginBottom:14 }}>
              <div style={SUBT}>{faltas.length === 0 ? "Tudo pronto para enviar" : "O que falta para enviar"}</div>
              <div style={{ height:6, background:"#E3E6EC", borderRadius:99, overflow:"hidden", marginBottom:12 }}><div style={{ width:pct + "%", height:"100%", background:"linear-gradient(90deg, #0B1B3D 0%, #1E3566 45%, #4A6BA8 100%)", borderRadius:99 }} /></div>
              <div style={{ display:"grid", gap:8 }}>
                {reqs.map(r => (
                  <div key={r.id} style={{ display:"flex", alignItems:"center", gap:10, background:"#fff", border:"1px solid " + (r.ok ? "#E3E6EC" : "#C9CED8"), borderRadius:10, padding:"9px 14px" }}>
                    <span style={{ width:22, height:22, borderRadius:"50%", display:"grid", placeItems:"center", flex:"none", background: r.ok ? "#067647" : "#fff", border: r.ok ? "2px solid #067647" : "2px solid #C9CED8", color:"#fff" }}>{r.ok && <Check size={13} aria-hidden="true" />}</span>
                    <span style={{ flex:1, fontSize:14, fontWeight:600, color: r.ok ? "#1A1D24" : "#0B1B3D" }}>{r.rot}</span>
                    {r.ok
                      ? <span style={{ fontSize:12.5, color:"#067647", fontWeight:600 }}>Preenchido</span>
                      : <button type="button" onClick={()=>focarCampo(r)} style={{ ...B.secundario, borderColor:"#1E3566", color:"#1E3566", padding:"6px 12px", fontSize:13 }}>Ir para o campo <ArrowRight size={14} aria-hidden="true" /></button>}
                  </div>
                ))}
              </div>
            </div>
            {podeEnviar ? (
              <div style={{ display:"flex", alignItems:"center", gap:14, flexWrap:"wrap" }}>
                <button type="button" onClick={()=>setJanelaPedido({ tipo, forcar:false, faltas:[] })} disabled={saving || faltas.length > 0} title={faltas.length ? "Falta: " + faltas.map(f => f.txt).join(", ") : "O CPCV está completo"}
                  style={faltas.length ? { ...B.secundario, background:"#E3E6EC", color:"#5B6272", borderColor:"#E3E6EC", cursor:"not-allowed", padding:"13px 28px", fontSize:15 } : { ...B.primario, background:"linear-gradient(90deg, #0B1B3D 0%, #1E3566 45%, #4A6BA8 100%)", borderColor:"transparent", padding:"13px 28px", fontSize:15 }}><Send size={18} aria-hidden="true" /> {rotulo}</button>
                {faltas.length > 0 && <>
                  <button type="button" onClick={()=>setJanelaPedido({ tipo, forcar:true, faltas: faltas.map(f => f.txt) })} disabled={saving} style={{ ...B.secundario, borderColor:"#1E3566", color:"#1E3566" }}>Forçar envio</button>
                  <span style={{ fontSize:13, color:"#5B6272" }}>Segue com {faltas.length} {faltas.length === 1 ? "item em falta" : "itens em falta"}, ficando marcado como incompleto.</span>
                </>}
              </div>
            ) : (
              <div style={{ fontSize:13.5, color:"#5B6272" }}>Só o angariador ou a líder podem enviar o pedido.</div>
            )}
          </>;
        })()}
      </div>
      {fase === "escritura" ? (
        <div style={{ display:"flex", justifyContent:"flex-start", margin:"0 0 16px" }}>
          <button type="button" onClick={()=>irPara("cpcv-cabecalho")} style={B.secundario}><ArrowLeft size={16} aria-hidden="true" /> Voltar ao pedido de CPCV</button>
        </div>
      ) : (() => {
        const i = FASES.findIndex(x => x.id === fase);
        const ant = FASES[i - 1], seg = FASES[i + 1];
        return (
          <div style={{ display:"flex", justifyContent:"space-between", gap:10, margin:"0 0 16px" }}>
            {ant ? <button type="button" onClick={()=>irPara(ant.sec)} style={B.secundario}><ArrowLeft size={16} aria-hidden="true" /> Anterior</button> : <span />}
            {seg ? <button type="button" onClick={()=>irPara(seg.sec)} style={B.primario}>Seguinte <ArrowRight size={16} aria-hidden="true" /></button> : <span />}
          </div>
        );
      })()}
      <div style={{ display:"flex", gap:10, justifyContent:"space-between", flexWrap:"wrap", marginBottom:40, padding:"14px 18px", background:"#fff", borderRadius:14, border:"1px solid #E3E6EC", boxShadow:"0 -4px 16px rgba(11,27,61,0.08)", position:"sticky", bottom:0, zIndex:15 }}>
        <button onClick={onVoltar} style={B.secundario}><ArrowLeft size={16} aria-hidden="true" /> Voltar</button>
        <div style={{ display:"flex", gap:10, flexWrap:"wrap" }}>
        <button onClick={()=>guardar(estadoAtualParaGuardar)} disabled={saving || soLeituraComprador} style={{ ...B.primario, order:1, cursor:saving?"not-allowed":"pointer", opacity:saving?0.7:1 }}><Save size={16} aria-hidden="true" /> {saving?"A guardar...":(escrituraDirecta?"GUARDAR · Direto p/ Escritura":"GUARDAR")}</button>
        {ultimaGravacao && <span style={{ order:2, alignSelf:"center", fontSize:12.5, color:"#5B6272" }}>Guardado às {ultimaGravacao.toLocaleTimeString("pt-PT",{hour:"2-digit",minute:"2-digit"})}</span>}
        <button onClick={()=>{
          const dataDefault = (escrituraDirecta?escrituraData:condicoes.data_assinatura_cpcv) ? new Date(escrituraDirecta?escrituraData:condicoes.data_assinatura_cpcv).toLocaleDateString("pt-PT") : new Date().toLocaleDateString("pt-PT");
          const data = window.prompt(escrituraDirecta?"Confirma a data da Escritura realizada:":"Confirma a data de assinatura do CPCV:", dataDefault);
          if(!data) return;
          const partes = data.split("/");
          const dataAssISO = partes.length===3 ? `${partes[2]}-${partes[1].padStart(2,"0")}-${partes[0].padStart(2,"0")}` : condicoes.data_assinatura_cpcv;
          setC("data_assinatura_cpcv", dataAssISO);
          setC("data_assinatura_confirmada", data);
          const vv = formatEur(valorTotal||imoveis[0]?.valor_venda||0);
          const sinal = formatEur(imoveis[0]?.valor_sinal||0);
          const aPagar = formatEur(Number(valorTotal||imoveis[0]?.valor_venda||0)-Number(imoveis[0]?.valor_sinal||0));
          const dataLimite = calcDataLimite(dataAssISO, prazoTipo, prazoTipo==="data"?condicoes.prazo_escritura:condicoes.prazo_dias);
          if(!window.confirm(escrituraDirecta?`✅ CONFIRMAR ESCRITURA REALIZADA\n\nData: ${data}\nValor de Venda: ${vv}\n\nAnexar documento da escritura? (podes fazê-lo depois)`:`✅ CONFIRMAR CPCV ASSINADO\n\nData: ${data}\nValor de Venda: ${vv}\nSinal: ${sinal}\nA pagar na Escritura: ${aPagar}${dataLimite?`\nData Limite Escritura: ${new Date(dataLimite).toLocaleDateString("pt-PT")}\n\nAnexar documento assinado? (podes fazê-lo depois)`:""}`)) return;
          const input = document.createElement("input");
          input.type = "file";
          input.accept = ".pdf,.jpg,.jpeg,.png";
          input.onchange = async (e) => {
            const file = e.target.files[0];
            if (file) {
              const path = `cpcv/${refImovel||"sem-ref"}/${Date.now()}_${file.name}`;
              const { error: upErr } = await supabase.storage.from("documentos-cpcv").upload(path, file);
              if (upErr) console.log("Upload erro:", upErr);
              else { setC("documento_assinado_path", path); alert("Documento anexado com sucesso!"); }
            }
            guardar("completo");
          };
          input.click();
          if(!input.files?.length) guardar("completo");
        }} disabled={saving} style={{ ...B.primario, order:5, cursor:saving?"not-allowed":"pointer", opacity:saving?0.7:1 }}><CheckCircle2 size={16} aria-hidden="true" /> {escrituraDirecta?"Escritura Realizada":"CPCV Assinado"}</button>
        {condicoes.documento_assinado_path && (
          <div style={{ display:"flex", alignItems:"center", gap:10, background:paleta.navy50, border:"1px solid " + paleta.cinza200, borderRadius:10, padding:"10px 16px", order:7 }}>
            <span style={{ fontSize:13, color:paleta.navy900, fontWeight:600 }}>Documento anexado</span>
            <button onClick={async()=>{
              const { data } = await supabase.storage.from("documentos-cpcv").createSignedUrl(condicoes.documento_assinado_path, 3600);
              if (data?.signedUrl) window.open(data.signedUrl, "_blank");
            }} style={{ background:"#1E3566", color:"#fff", border:"none", borderRadius:7, padding:"5px 12px", fontSize:12, fontWeight:600, cursor:"pointer" }}>Ver / Descarregar</button>
            <button onClick={()=>{ if(window.confirm("Remover documento?")) setC("documento_assinado_path",""); }} style={{ background:"#fef2f2", color:"#ef4444", border:"none", borderRadius:7, padding:"5px 10px", fontSize:12, cursor:"pointer" }}>🗑</button>
          </div>
        )}
        {!condicoes.documento_assinado_path && formulario?.estado==="completo" && (
          <button onClick={()=>{
            const input = document.createElement("input");
            input.type = "file";
            input.accept = ".pdf,.jpg,.jpeg,.png";
            input.onchange = async(e)=>{
              const file = e.target.files[0];
              if (!file) return;
              const path = `cpcv/${refImovel||"sem-ref"}/${Date.now()}_${file.name}`;
              const { error } = await supabase.storage.from("documentos-cpcv").upload(path, file);
              if (!error) { setC("documento_assinado_path", path); await guardar("completo"); alert("Documento guardado!"); }
            };
            input.click();
          }} style={{ ...B.secundario, order:7 }}><Paperclip size={16} aria-hidden="true" /> Anexar Documento Assinado</button>
        )}
        {/* Cancelar o CPCV (rascunho ou pedido) cancela o processo todo: proposta, negócio e comissões. Nada é apagado. */}
        {formulario?.id && souAngariador && formulario?.estado !== "cancelado" && (
          <button onClick={async ()=>{
            if (formulario.negocio_id && onCancelarProcesso) {
              if (!window.confirm("Cancelar este CPCV?\n\nCancela o processo todo: a proposta, o negócio e as comissões ficam cancelados (nada é apagado). Os contactos e a angariação ficam como estão.\n\nA seguir indica o motivo e quem desistiu.")) return;
              onCancelarProcesso(formulario.negocio_id);
              return;
            }
            const motivo = window.prompt("Cancelar este CPCV. Motivo:");
            if (motivo === null) return;
            const { error } = await supabase.from("formularios_cpcv").update({ estado:"cancelado", cancelado_em:new Date().toISOString(), cancelado_por:profile?.id||null, motivo_cancelamento:motivo||null }).eq("id", formulario.id);
            if (error) { alert("Não foi possível cancelar: " + error.message); return; }
            alert("CPCV cancelado."); onVoltar();
          }} style={{ ...B.perigo, order:100, marginLeft:"auto" }}><XCircle size={16} aria-hidden="true" /> Cancelar CPCV</button>
        )}
        {janelaPedido && <JanelaPedidoCpcv tipo={janelaPedido.tipo} forcar={janelaPedido.forcar} faltas={janelaPedido.faltas} aEnviar={saving}
          emailConsultor={janelaPedido.tipo === "externo" ? (profile?.email || "") : ((consultores||[]).find(c => c.id === papeisNeg?.ang)?.email || profile?.email || "")}
          emailRemetente={profile?.email || ""}
          pdf={pdfPedido}
          emailsSugeridos={[agExtAngariadora?.email].filter(Boolean)}
          onCancelar={()=>setJanelaPedido(null)} onEnviar={enviarPedido} />}
        <button onClick={()=>setPdfModal(true)} style={{ ...B.primario, order:6 }}><FileDown size={16} aria-hidden="true" /> Criar PDF</button>
        {pdfModal && (
          <div style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.45)", zIndex:2000, display:"flex", alignItems:"center", justifyContent:"center" }} onClick={()=>setPdfModal(false)}>
            <div style={{ background:"#fff", borderRadius:16, padding:28, width:380, maxWidth:"90vw" }} onClick={e=>e.stopPropagation()}>
              <div style={{ fontWeight:700, fontSize:15, color:"#1a1a2e", marginBottom:16 }}>📄 Selecionar conteúdo do PDF</div>
              {[
                { id:"compradores", l:"Compradores", opcoes:{ cabecalho:true, imoveis:false, vendedores:false, compradores:true, condicoes:false } },
                { id:"compradores_condicoes", l:"Compradores + Condições", opcoes:{ cabecalho:true, imoveis:false, vendedores:false, compradores:true, condicoes:true } },
                { id:"vendedores_condicoes", l:"Vendedores + Condições", opcoes:{ cabecalho:true, imoveis:false, vendedores:true, compradores:false, condicoes:true } },
                { id:"tudo", l:"Processo Completo", opcoes:{ cabecalho:true, imoveis:true, vendedores:true, compradores:true, condicoes:true } },
              ].map(({id,l,opcoes})=>(
                <label key={id} onClick={()=>{ setPdfOpcaoId(id); setPdfOpcoes(opcoes); }} style={{ display:"flex", alignItems:"center", gap:10, padding:"10px 12px", borderRadius:8, cursor:"pointer", background: pdfOpcaoId===id?"#f0fdf4":"#f8f7f4", border: pdfOpcaoId===id?"1.5px solid #bbf7d0":"1.5px solid #ece9e3", marginBottom:8 }}>
                  <div style={{ width:18, height:18, borderRadius:"50%", border:"2px solid", borderColor: pdfOpcaoId===id?"#16a34a":"#d1d5db", background: pdfOpcaoId===id?"#16a34a":"#fff", flexShrink:0 }} />
                  <span style={{ fontSize:13, color:"#1a1a2e", fontWeight: pdfOpcaoId===id?700:400 }}>{l}</span>
                </label>
              ))}
              <div style={{ display:"flex", gap:10, marginTop:20, justifyContent:"flex-end" }}>
                <button onClick={()=>setPdfModal(false)} style={{ background:"#f3f4f6", border:"none", borderRadius:8, padding:"9px 18px", fontSize:13, cursor:"pointer" }}>Cancelar</button>
                <button style={{ background:"#1a1a2e", color:"#fff", border:"none", borderRadius:8, padding:"9px 20px", fontSize:13, fontWeight:600, cursor:"pointer" }} onClick={()=>{ setPdfModal(false); gerarPDF(pdfOpcoes); }}>Gerar PDF</button>
              </div>
            </div>
          </div>
        )}
        </div>
      </div>
    </div>
  );
}
